<div
  class="modal fade show d-block"
  id="basicModal1"
  tabindex="-1"
  style="background: rgba(0, 0, 0, 0.5)"
>
  <div
    class="modal-dialog modal-dialog-centered"
    style="width: 100vw; max-width: 100%; margin: 0; padding: 10px"
  >
    <div
      class="modal-content"
      style="
        height: 95vh;
        max-height: 95vh;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
      "
    >
      <!-- Sticky Header -->
      <!-- Sticky Header -->
      <div
        class="header-height"
        style="
          position: sticky;
          top: 0;
          z-index: 100;
          background-color: #142a49;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: white;
          min-height: 29px;
        "
      >
        <label
          class="headingFontSize"
          style="background-color: #142a49; margin-left: 15px"
        >
          {{ productModalMode === "view" ? "View Product" : "Update Product" }}
        </label>
        <button
          (click)="handleCancel()"
          type="button"
          class="btn-close"
          style="width: 10px; height: 10px; margin-right: 5px"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <!-- Main Content -->
      <div>
        <div
          style="display: flex; align-items: center; flex-wrap: wrap; gap: 15px"
        >
          <!-- my first row -->
          <div
            class="my-first-row"
            [ngClass]="
              product.productInfo.productNewInputIdentifier || showOtherInput
                ? 'my-first-row-wrap'
                : ''
            "
            style="
              display: flex;
              gap: 10px;
              width: 100%;
              justify-content: space-between;
              padding: 15px;
            "
          >
            <!-- Product ID -->
            <div style="flex: 1 1 13%; min-width: 160px">
              <label class="fontSize">Product ID</label>
              <input
                disabled
                [(ngModel)]="product.productInfo.productId"
                type="text"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Product ID"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
              />
            </div>

            <!-- Product Name -->
            <div style="flex: 1 1 13%; min-width: 160px">
              <label class="fontSize">Product Name</label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="product.productInfo.productName"
                placeholder="Product Name"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
              />
            </div>

            <!-- Product Identifier -->
            <div style="flex: 1 1 13%; min-width: 160px">
              <label class="fontSize">Product Identifier</label>
              <ng-multiselect-dropdown
                [placeholder]="'Product Identifier'"
                [settings]="countryDropdownSettings"
                [data]="productIdentifier"
                [(ngModel)]="product.productInfo.productIdentifier"
                (onSelect)="onSelectProductIdentityFier($event)"
                (onDeSelect)="onDeselectProductIdentityFier($event)"
                style="
                  font-size: 11px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              >
              </ng-multiselect-dropdown>
            </div>
            <div
              *ngIf="
                product.productInfo.productNewInputIdentifier || showOtherInput
              "
              style="flex: 1 1 13%; min-width: 160px"
            >
              <label class="fontSize">New Product Identifier</label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="product.productInfo.productNewInputIdentifier"
                placeholder="Enter new name"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              />
            </div>

            <!-- Effective Distribution Date -->
            <div style="flex: 1 1 13%; min-width: 160px">
              <label class="fontSize">Effective Distribution Date</label>
              <input
                type="date"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="product.productInfo.effectiveDistributionDate"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                "
              />
            </div>

            <!-- Distribution Country -->
            <div style="flex: 1 1 13%; min-width: 160px">
              <label class="fontSize">Distribution Country</label>
              <ng-multiselect-dropdown
                [placeholder]="'Select Country'"
                [settings]="countryDropdownSettings"
                [data]="countries"
                [(ngModel)]="product.productInfo.productCountry"
                style="
                  font-size: 11px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
              >
              </ng-multiselect-dropdown>
            </div>

            <!-- Distribution Provinces -->
            <div style="flex: 1 1 13%; min-width: 160px">
              <label class="fontSize">Distribution Provinces</label>
              <ng-multiselect-dropdown
                [placeholder]="'Select Provinces'"
                [settings]="dropdownSettings"
                [data]="provinces"
                [(ngModel)]="product.productInfo.selectedProvinces"
                (onSelect)="onItemSelect($event)"
                (onDeSelect)="onItemDeSelect($event)"
                (onSelectAll)="onSelectAll($event)"
                (onDeSelectAll)="onDeSelectAll($event)"
                style="
                  font-size: 11px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
              >
              </ng-multiselect-dropdown>
            </div>

            <!-- Renewal Date -->
            <div style="flex: 1 1 13%; max-width: 160px">
              <label class="fontSize">Renewal Date</label>
              <input
                type="date"
                [(ngModel)]="product.productInfo.renewalDate"
                [ngModelOptions]="{ standalone: true }"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                "
              />
            </div>
          </div>
          <!-- second row -->
          <div style="width: 100%" *ngIf="product.limits">
            <!-- Limits -->
            <div style="width: 100%; display: flex; flex-direction: column">
              <!-- Section Header -->
              <div
                class="header-height"
                style="
                  background: #142a49;
                  color: white;
                  border-top: 1px solid #ddd;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  position: relative;
                "
              >
                <label
                  class="headingFontSize"
                  style="background: #142a49; margin-left: 15px"
                >
                  Limits&nbsp;<i class="bi bi-info-circle"></i>
                </label>
              </div>

              <div
                class="limits"
                style="
                  display: flex;
                  width: fit-content;
                  column-gap: 30px;
                  padding-left: 5px;
                "
              >
                <!-- COB rules -->
                <div
                  style="
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    column-gap: 10px;
                  "
                >
                  <label class="fontSize">C. O. B. Rules Apply?</label>
                  <div style="display: flex; align-items: center">
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        font-size: 13px;
                        margin-right: 10px;
                      "
                    >
                      <input
                        type="radio"
                        name="COB"
                        [(ngModel)]="product.limits.isCOB"
                        [value]="true"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        font-size: 13px;
                      "
                    >
                      <input
                        type="radio"
                        name="COB"
                        [(ngModel)]="product.limits.isCOB"
                        [value]="false"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>
                </div>

                <!-- Age Limited -->
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    padding: 10px;
                    gap: 20px;
                    align-items: center;
                  "
                >
                  <div
                    class="fontSize"
                    style="display: flex; align-items: center; gap: 10px"
                  >
                    <label class="fontSize" style="margin-right: 10px">{{
                      lang.Age_Limited
                    }}</label>
                    <label
                      style="
                        font-size: 13px;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <input
                        type="radio"
                        name="ageLimit"
                        [(ngModel)]="product.limits.isAgeLimitEnabled"
                        [value]="true"
                        style="margin-right: 5px; cursor: pointer"
                      />
                      Yes
                    </label>
                    <label
                      style="
                        font-size: 13px;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <input
                        type="radio"
                        name="ageLimit"
                        [(ngModel)]="product.limits.isAgeLimitEnabled"
                        [value]="false"
                        style="margin-right: 5px; cursor: pointer"
                      />
                      No
                    </label>
                  </div>

                  <!-- Age Inputs -->
                  <div
                    *ngIf="product.limits.isAgeLimitEnabled"
                    style="
                      display: flex;
                      flex-wrap: wrap;
                      gap: 10px;
                      align-items: flex-end;
                      margin-top: -5px;
                    "
                  >
                    <!-- Min Age -->
                    <div
                      style="display: flex; flex-direction: column; width: 80px"
                    >
                      <label class="fontSmallSize">{{ lang.Min_Age }}</label>
                      <input
                        type="number"
                        [(ngModel)]="product.limits.minAge"
                        (input)="validateAgeRange()"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                    </div>

                    <!-- Max Age -->
                    <div
                      style="display: flex; flex-direction: column; width: 80px"
                    >
                      <label class="fontSmallSize">{{ lang.Max_Age }}</label>
                      <input
                        type="number"
                        [(ngModel)]="product.limits.maxAge"
                        (input)="validateAgeRange()"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                    </div>

                    <!-- Child Age Out -->
                    <div
                      style="display: flex; flex-direction: column; width: 80px"
                    >
                      <label class="fontSmallSize" style="width: 110px"
                        >Child Age Out</label
                      >
                      <input
                        type="text"
                        [(ngModel)]="product.limits.childAgeOut"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                    </div>

                    <!-- Student Age Out -->
                    <div
                      style="display: flex; flex-direction: column; width: 80px"
                    >
                      <label class="fontSmallSize" style="width: 110px"
                        >Student Age Out</label
                      >
                      <input
                        type="text"
                        [(ngModel)]="product.limits.studentAgeOut"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                    </div>
                  </div>
                  <!-- Error Message -->
                  <div
                    *ngIf="ageError"
                    style="color: red; font-size: 12px; margin-top: 5px"
                  >
                    {{ ageError }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Third row -->
          <!-- Product Details and Vendor Invoicing and payments -->
          <div
            class="product_details"
            style="width: 100%; display: flex; column-gap: 10px"
          >
            <div style="width: 100%; display: flex; flex-direction: column">
              <!-- heading of product details -->
              <div
                class="header-height"
                style="
                  width: 100%;
                  background: #142a49;
                  color: white;
                  border-top: 1px solid #ddd;
                "
              >
                <label
                  class="headingFontSize"
                  style="margin-left: 15px; background-color: #142a49"
                >
                  {{ lang.Product_Details }}&nbsp;<i
                    class="bi bi-info-circle"
                  ></i>
                </label>
              </div>

              <div style="display: flex; margin-top: -7px">
                <!--Booklet Template -->
                <!-- ********************************** Toolkit PDF ********************************************* -->
                <!--Toolkit Template -->
                <div style="width: 100%; padding: 10px; padding-left: 15px">
                  <label class="fontSize">Booklet</label><br />
                  <div style="position: relative; width: 100%; height: 34px">
                    <input
                      type="file"
                      (change)="handleTookletFile($event)"
                      id="ToolkitUpload"
                      accept="application/pdf"
                      multiple
                      style="display: none"
                    />
                    <label
                      for="ToolkitUpload"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 30px;
                        font-size: 13px;
                        border: 1px solid #ccc;
                        border-radius: 5px;
                        background: #e8eaf0;
                        cursor: pointer;
                        padding-right: 36px;
                        box-sizing: border-box;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: all 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#3b82f6';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      onmouseover="this.style.boxShadow='0 2px 5px rgba(0,0,0,0.10)'"
                      onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'"
                    >
                      Choose File
                    </label>

                    <!-- Eye Icon -->
                    <div
                      *ngIf="product.productDetails.bookletFile.length > 0"
                      (click)="showPopup = true"
                      style="
                        position: absolute;
                        top: 45%;
                        right: 10px;
                        transform: translateY(-50%);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 100%;
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="#0c2d48"
                        style="cursor: pointer"
                      >
                        <path
                          d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
         11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
         5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
         3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                        />
                      </svg>
                      <span
                        style="
                          font-size: 14px;
                          margin-left: 2px;
                          margin-top: -2px;
                        "
                        >{{ product.productDetails.bookletFile.length }}</span
                      >
                    </div>
                  </div>

                  <!-- Show File Name -->
                  <div
                    *ngIf="product.productDetails.bookletFile.length > 0"
                    style="width: 100%; font-size: 12px; color: #333"
                  >
                    <strong
                      >{{
                        product.productDetails.bookletFile.length === 1
                          ? "File"
                          : "File's"
                      }}
                      Uploaded</strong
                    >
                  </div>
                </div>

                <!-- Toolkit Popup  -->
                <div
                  *ngIf="showPopup"
                  class="modal fade show d-block"
                  data-bs-backdrop="static"
                  tabindex="-1"
                  style="background: rgba(0, 0, 0, 0.5)"
                >
                  <div
                    class="modal-dialog modal-lg modal-dialog-centered"
                    style="width: 40%"
                  >
                    <div
                      class="modal-content"
                      style="border-radius: 8px; overflow: hidden"
                    >
                      <!-- Header -->
                      <div
                        class="header-height"
                        style="
                          background-color: #5d7c9b;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          padding: 10px 15px;
                        "
                      >
                        <h6
                          style="
                            color: white;
                            margin: 0;
                            font-size: 16px;
                            font-weight: 600;
                            background-color: #5d7c9b;
                          "
                        >
                          Uploaded PDF List
                        </h6>
                        <button
                          (click)="showPopup = false"
                          type="button"
                          class="btn-close"
                          style="filter: invert(1); opacity: 0.9"
                        ></button>
                      </div>

                      <!-- Body -->
                      <div
                        style="
                          padding: 16px;
                          max-height: 300px;
                          overflow-y: auto;
                        "
                      >
                        <div
                          *ngFor="
                            let pdf of product.productDetails.bookletFile;
                            let i = index
                          "
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 8px 0;
                            border-bottom: 1px solid #e0e0e0;
                          "
                        >
                          <!-- File Name -->
                          <span style="flex: 1; font-size: 14px; color: #333">
                            {{ pdf.name }}
                          </span>

                          <!-- Eye Icon -->
                          <span
                            (click)="viewPdf(pdf.base64Data, pdf.name)"
                            style="margin-right: 10px; cursor: pointer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="#0c2d48"
                            >
                              <path
                                d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
              11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
              5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
              3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                              />
                            </svg>
                          </span>

                          <!-- Delete Icon -->
                          <span
                            (click)="deletePdf(i)"
                            style="cursor: pointer; color: #b22222"
                          >
                            <i class="bi bi-trash-fill"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PDF Popup -->
                <div
                  *ngIf="showToolkitPDF"
                  class="modal fade show d-block"
                  data-bs-backdrop="static"
                  tabindex="-1"
                  style="background: rgba(0, 0, 0, 0.5)"
                >
                  <div
                    style="width: 40%"
                    class="modal-dialog modal-lg modal-dialog-centered"
                  >
                    <div class="modal-content">
                      <!-- Header -->
                      <div
                        class="header-height"
                        style="
                          background-color: #5d7c9b;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          padding: 10px 15px;
                        "
                      >
                        <h6
                          class="fontSize"
                          style="
                            color: white;
                            margin: 0;
                            background-color: #5d7c9b;
                          "
                        >
                          Preview : {{ currentPDFName }}
                        </h6>
                        <button
                          (click)="showToolkitPDF = false"
                          style="margin: 3px"
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>

                      <!-- Body -->
                      <iframe
                        [src]="currentPdfUrl"
                        width="100%"
                        height="500px"
                      ></iframe>
                    </div>
                  </div>
                </div>

                <!-- Product Resource Info -->
                <div style="width: 100%; padding: 10px; padding-left: 15px">
                  <label class="fontSize">Product Resource Info</label><br />
                  <div
                    style="
                      position: relative;
                      width: 100%;
                      height: 34px;
                      margin-bottom: -6px;
                    "
                  >
                    <label
                      (click)="handleProductResource()"
                      for="Resource"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 30px;
                        font-size: 13px;
                        border: 1px solid #ccc;
                        border-radius: 5px;
                        background: #e8eaf0;
                        cursor: pointer;
                        padding-right: 36px;
                        box-sizing: border-box;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: all 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#3b82f6';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      onmouseover="this.style.boxShadow='0 2px 5px rgba(0,0,0,0.10)'"
                      onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'"
                    >
                      {{
                        product.productDetails.productResourceContent ||
                        savedProductResourceContent
                          ? "Edit File"
                          : "Create File"
                      }}
                    </label>

                    <!-- Eye Icon -->
                    <div
                      *ngIf="
                        product.productDetails.productResourceContent ||
                        savedProductResourceContent
                      "
                      (click)="onViewProduct_Resource_Description()"
                      style="
                        position: absolute;
                        top: 45%;
                        right: 10px;
                        transform: translateY(-50%);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 100%;
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="#0c2d48"
                        style="cursor: pointer"
                      >
                        <path
                          d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
         11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
         5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
         3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                        />
                      </svg>
                    </div>
                  </div>

                  <!-- saved name -->
                  <!-- saved name -->
                  <span
                    *ngIf="
                      product.productDetails.productResourceContent.length >
                        0 || savedProductResourceContent
                    "
                    style="font-size: 12px; font-weight: 500; color: darkgrey"
                    >Saved File</span
                  >
                </div>

                <!--************************** *Tile Description ***************************////////////-->
                <div style="width: 100%; padding: 10px; padding-left: 15px">
                  <label class="fontSize">Tile Description</label><br />

                  <div
                    style="
                      position: relative;
                      width: 100%;
                      height: 34px;
                      margin-bottom: -6px;
                    "
                  >
                    <!-- Styled Label as Fake Button -->
                    <label
                      (click)="handleTileDecription()"
                      for="bookletUpload"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 30px;
                        font-size: 13px;
                        border: 1px solid #ccc;
                        border-radius: 5px;
                        background: #e8eaf0;
                        cursor: pointer;
                        padding-right: 36px;
                        box-sizing: border-box;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: all 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#3b82f6';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      onmouseover="this.style.boxShadow='0 2px 5px rgba(0,0,0,0.10)'"
                      onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'"
                    >
                      {{
                        product.productDetails.tileDescriptionContent ||
                        savedContent
                          ? "Edit File"
                          : "Create File"
                      }}
                    </label>

                    <!-- Eye Icon -->
                    <div
                      *ngIf="
                        product.productDetails.tileDescriptionContent ||
                        savedContent
                      "
                      (click)="onViewTileDescription()"
                      style="
                        position: absolute;
                        top: 45%;
                        right: 10px;
                        transform: translateY(-50%);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 100%;
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="#0c2d48"
                        style="cursor: pointer"
                      >
                        <path
                          d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
          11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
          5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
          3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                        />
                      </svg>
                    </div>
                  </div>

                  <!-- saved name -->
                  <span
                    *ngIf="
                      product.productDetails.tileDescriptionContent ||
                      savedContent
                    "
                    style="font-size: 12px; font-weight: 500; color: darkgrey"
                    >Saved File</span
                  >
                </div>
              </div>
               <!-- akash george -->
              <!-- Health Card/Certificate Section -->
              <div
                style="
                  padding-left: 15px;
                  display: flex;
                  flex-direction: column;
                  row-gap: 10px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: flex-start; /* horizontal alignment */
                    gap: 20px; /* reduced gap between Q1 and Q2 */
                    margin-top: 10px;
                  "
                >
                  <!-- Q1: Does this product have any health card/certificate? -->
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      gap: 6px; /* reduced gap between label and radios */
                    "
                  >
                    <label
                      style="
                        font-size: 14px;
                        width: 320px; /* increased width so text stays in one line */
                      "
                    >
                      Does this product have any health card/certificate?
                    </label>

                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 13px;
                      "
                    >
                      <input
                        type="radio"
                        name="hasCard"
                        [(ngModel)]="
                          product.productDetails.getHealthCardsPayload.hasCard
                        "
                        [value]="true"
                        [ngModelOptions]="{ standalone: true }"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>

                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        font-size: 13px;
                      "
                    >
                      <input
                        type="radio"
                        name="hasCard"
                        [(ngModel)]="
                          product.productDetails.getHealthCardsPayload.hasCard
                        "
                        [value]="false"
                        [ngModelOptions]="{ standalone: true }"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>

                  <!-- Q2: If Yes -> Number of product.productDetails.getHealthCardsPayload.cards/certificates -->
                  <div
                    *ngIf="product.productDetails.getHealthCardsPayload.hasCard"
                    style="
                      display: flex;
                      align-items: center;
                      gap: 6px; /* reduced gap between label and input */
                      margin-top: -5px;
                    "
                  >
                    <label
                      style="
                        font-size: 14px;
                        width: 150px; /* smaller since text is short */
                      "
                    >
                      No. of cards/certificates
                    </label>

                    <input
                      type="text"
                      [(ngModel)]="
                        product.productDetails.getHealthCardsPayload.numCards
                      "
                      min="1"
                      (keydown)="validateInteger($event)"
                      (paste)="validatePaste($event)"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onNumCardsChange($event)"
                      placeholder="No. of cards/certificates"
                      style="
                        height: 30px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />
                  </div>
                </div>

                <!-- Q3: Dynamic table for each card/certificate -->
                <div
                  *ngIf="
                    product.productDetails.getHealthCardsPayload.hasCard &&
                    product.productDetails.getHealthCardsPayload.numCards > 0
                  "
                  style="padding-right: 5px; padding-bottom: 2px"
                >
                  <div style="width: 100%; max-width: 600px; margin-top: 5px">
                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 12px;
                        border: 1px solid #ccc;
                      "
                    >
                      <thead style="background: #808285; color: white">
                        <tr>
                          <th
                            style="
                              padding: 6px;
                              width: 10%;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                              text-align: center;
                            "
                          >
                            No
                          </th>
                          <th
                            style="
                              padding: 6px;
                              width: 45%;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Card/Certificate Type
                          </th>
                          <th
                            style="
                              padding: 6px;
                              width: 45%;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Source
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          *ngFor="
                            let row of product.productDetails
                              .getHealthCardsPayload.cards;
                            let i = index
                          "
                        >
                          <!-- # -->
                          <td
                            style="
                              padding: 2px 4px;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                              text-align: center;
                            "
                          >
                            {{ i + 1 }}
                          </td>

                          <!-- Type dropdown (single-select) -->
                          <td
                            style="
                              padding: 2px 4px;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            <ng-multiselect-dropdown
                              [placeholder]="'Select Type'"
                              [settings]="singleSelectDropdownSettings"
                              [data]="cardTypeOptions"
                              [(ngModel)]="
                                product.productDetails.getHealthCardsPayload
                                  .cards[i].type
                              "
                              [ngModelOptions]="{ standalone: true }"
                              style="
                                font-size: 11px;
                                outline: none;
                                background-color: #e8eaf0;
                                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                transition: box-shadow 0.2s ease,
                                  border-color 0.2s ease;
                                text-transform: capitalize;
                              "
                              onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                              onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                            >
                            </ng-multiselect-dropdown>
                          </td>

                          <!-- Source dropdown (single-select) -->
                          <td
                            style="
                              padding: 2px 4px;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            <ng-multiselect-dropdown
                              [placeholder]="'Select Source'"
                              [settings]="singleSelectDropdownSettings"
                              [data]="cardSourceOptions"
                              [(ngModel)]="
                                product.productDetails.getHealthCardsPayload
                                  .cards[i].source
                              "
                              [ngModelOptions]="{ standalone: true }"
                              style="
                                font-size: 11px;
                                outline: none;
                                background-color: #e8eaf0;
                                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                transition: box-shadow 0.2s ease,
                                  border-color 0.2s ease;
                                text-transform: capitalize;
                              "
                              onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                              onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                            >
                            </ng-multiselect-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- show the preview of tile -->
              <!--  Booklet Preview Popup  -->
              <div
                *ngIf="showTileExcelPopup"
                class="popup-wrapper"
                style="
                  position: fixed;
                  top: 0;
                  left: 0;
                  z-index: 1000;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.4);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  class="popup-content"
                  style="
                    background: white;
                    width: 90%;
                    max-width: 900px;
                    height: 90vh;
                    overflow-y: hidden;
                    border-radius: 10px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
                  "
                >
                  <!-- Title Bar -->
                  <div
                    class="header-height"
                    style="
                      background-color: #5d7c9b;
                      color: white;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span style="margin-left: 5px" class="fontSize"
                      >Booklet Preview</span
                    >
                    <button
                      (click)="resetTilePreview()"
                      style="
                        border: none;
                        background: transparent;
                        font-size: 20px;
                        color: white;
                        cursor: pointer;
                      "
                      title="Close"
                    >
                      &#10005;
                    </button>
                  </div>

                  <!-- File Preview Content -->
                  <div style="padding: 20px">
                    <div
                      style="
                        margin-top: 10px;
                        overflow: hidden;
                        margin-top: -18px;
                      "
                    >
                      <div
                        style="
                          transform: scale(0.6);
                          transform-origin: top left;
                          width: 166.67%;
                          height: 1200px;
                        "
                      >
                        <iframe
                          [src]="bookletUrl"
                          width="100%"
                          height="100%"
                          style="border: none; margin-top: -50px"
                        ></iframe>
                      </div>
                    </div>
                    <div *ngIf="tilePreviewType === 'unsupported'">
                      <p>This file type is not supported for preview.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!--Product Resource Description Editor Quill editor -->
              <div
                *ngIf="showProduct_Resource_QuillEditor"
                class="modal fade show d-block"
                data-bs-backdrop="static"
                tabindex="-1"
                style="background: rgba(0, 0, 0, 0.5)"
              >
                <div
                  style="width: 40%"
                  class="modal-dialog modal-lg modal-dialog-centered"
                >
                  <div class="modal-content">
                    <!-- Header -->
                    <div
                      class="header-height"
                      style="
                        background-color: #5d7c9b;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 10px 15px;
                      "
                    >
                      <h6
                        class="fontSize"
                        style="
                          color: white;
                          margin: 0;
                          background-color: #5d7c9b;
                        "
                      >
                        Product Resource Description
                      </h6>
                      <button
                        (click)="onCanceloOfProductResourceDescription()"
                        style="margin: 3px"
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body" style="padding: 10px">
                      <quill-editor
                        [(ngModel)]="tempForProductResource"
                        [modules]="quillModulesForProductResource"
                        [styles]="{ height: '250px' }"
                        placeholder="Start writing here..."
                      >
                      </quill-editor>
                    </div>

                    <!-- Footer -->
                    <div
                      class="modal-footer"
                      style="
                        padding: 10px 15px;
                        justify-content: flex-end;
                        gap: 10px;
                      "
                    >
                      <button
                        style="
                          padding: 6px 20px;
                          background-color: white;
                          border: 1px solid #142a49;
                          border-radius: 10px;
                          color: black;
                          font-size: 14px;
                          font-weight: 500;
                          cursor: pointer;
                        "
                        (click)="onCanceloOfProductResourceDescription()"
                      >
                        Cancel
                      </button>

                      <button
                        style="
                          padding: 6px 20px;
                          background-color: #142a49;
                          border: 1px solid #4883f2;
                          border-radius: 10px;
                          color: white;
                          font-size: 14px;
                          font-weight: 500;
                          cursor: pointer;
                        "
                        (click)="onProductResourceFileSave()"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!--Tile Description Editor Quill editor -->
              <div
                *ngIf="showTileQuillEditor"
                class="modal fade show d-block"
                data-bs-backdrop="static"
                tabindex="-1"
                style="background: rgba(0, 0, 0, 0.5)"
              >
                <div
                  style="width: 40%"
                  class="modal-dialog modal-lg modal-dialog-centered"
                >
                  <div class="modal-content">
                    <!-- Header -->
                    <div
                      class="header-height"
                      style="
                        background-color: #5d7c9b;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 10px 15px;
                      "
                    >
                      <h6
                        class="fontSize"
                        style="
                          color: white;
                          margin: 0;
                          background-color: #5d7c9b;
                        "
                      >
                        Tile Description
                      </h6>
                      <button
                        (click)="onCanceloOfTileDescription()"
                        style="margin: 3px"
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body" style="padding: 10px">
                      <quill-editor
                        [(ngModel)]="tempForTileDescription"
                        [modules]="quillModules"
                        [styles]="{ height: '250px' }"
                        placeholder="Start writing here..."
                      >
                      </quill-editor>
                      <div style="position: relative; width: 40%; height: 34px">
                        <!-- Hidden File Input -->
                        <input
                          #fileInput
                          type="file"
                          accept="image/*"
                          id="ToolkitUpload"
                          (change)="handleTileLogo($event)"
                          hidden
                        />

                        <!-- Styled Button -->
                        <button
                          for="ToolkitUpload"
                          (click)="fileInput.click()"
                          class="btn btn-sm fontSize"
                          style="
                            margin-top: 2px;
                            font-size: 14px;
                            padding: 4px 12px;
                            border-radius: 4px;
                            background-color: white;
                            border: 1px solid #142a49;
                            color: #142a49;
                            cursor: pointer;
                          "
                        >
                          Choose Logo
                        </button>
                      </div>
                    </div>
                    <img
                      *ngIf="product.productDetails.tileLogo"
                      [src]="product.productDetails.tileLogo"
                      alt="Preview"
                      style="
                        max-width: 200px;
                        margin-top: 3px;
                        margin-left: 10px;
                        border: 1px solid #ccc;
                      "
                    />

                    <!-- Footer -->
                    <div
                      class="modal-footer"
                      style="
                        padding: 10px 15px;
                        justify-content: flex-end;
                        gap: 10px;
                      "
                    >
                      <button
                        style="
                          padding: 6px 20px;
                          background-color: white;
                          border: 1px solid #142a49;
                          border-radius: 10px;
                          color: black;
                          font-size: 14px;
                          font-weight: 500;
                          cursor: pointer;
                        "
                        (click)="onCanceloOfTileDescription()"
                      >
                        Cancel
                      </button>

                      <button
                        style="
                          padding: 6px 20px;
                          background-color: #142a49;
                          border: 1px solid #4883f2;
                          border-radius: 10px;
                          color: white;
                          font-size: 14px;
                          font-weight: 500;
                          cursor: pointer;
                        "
                        (click)="onTileFileSave()"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- quill view Tile Description-->
              <!-- Preview Popup with Quill content -->
              <div
                *ngIf="previewQuillEditor"
                class="popup-wrapper"
                style="
                  position: fixed;
                  top: 0;
                  left: 0;
                  z-index: 1000;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.4);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  class="popup-content"
                  style="
                    background: white;
                    width: fit-content;
                    min-width: 420px;
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
                  "
                >
                  <!-- Title Bar -->
                  <div
                    class="header-height"
                    style="
                      background-color: #5d7c9b;
                      color: white;
                      font-weight: 500;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span class="fontSize" style="margin-left: 10px"
                      >Tile Description Preview</span
                    >
                    <button
                      (click)="onClosePopup()"
                      style="margin: 3px"
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <!-- Preview Body -->
                  <div
                    style="
                      flex-grow: 1;
                      padding: 20px;
                      overflow-y: auto;
                      max-height: 80vh;
                    "
                  >
                    <div
                      style="
                        width: 400px;
                        background-color: #fff0f5;
                        border-radius: 10px;
                        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                      "
                    >
                      <!-- Default image -->
                      <div style="width: 100%; text-align: center">
                        <img
                          id="image"
                          style="
                            border-top-left-radius: 6px;
                            border-top-right-radius: 6px;
                          "
                          *ngIf="product.productDetails.tileLogo"
                          [src]="product.productDetails.tileLogo"
                          width="100%"
                        />
                      </div>

                      <!-- Rendered Quill content -->
                      <div
                        style="margin-top: -5px"
                        class="ql-editor"
                        [innerHTML]="product.productDetails.tileDescriptionHTML"
                      ></div>
                    </div>
                  </div>

                  <!-- Footer -->
                  <div
                    style="
                      padding: 10px 16px;
                      display: flex;
                      justify-content: flex-end;
                      gap: 10px;
                    "
                  >
                    <button
                      style="
                        padding: 6px 20px;
                        background-color: #142a49;
                        border: 1px solid #4883f2;
                        border-radius: 10px;
                        color: white;
                        font-size: 14px;
                        font-weight: 500;
                        cursor: pointer;
                      "
                      (click)="onClosePopup()"
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
              <!-- Preview Popup with Product Description Quill content -->
              <div
                *ngIf="previewProduct_Resource_QuillEditor"
                class="popup-wrapper"
                style="
                  position: fixed;
                  top: 0;
                  left: 0;
                  z-index: 1000;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.4);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  class="popup-content"
                  style="
                    background: white;
                    width: fit-content;
                    min-width: 420px;
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
                  "
                >
                  <!-- Title Bar -->
                  <div
                    class="header-height"
                    style="
                      background-color: #5d7c9b;
                      color: white;
                      font-weight: 500;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span class="fontSize" style="margin-left: 10px"
                      >Product Description Preview</span
                    >
                    <button
                      (click)="onProductPreviewClosePopup()"
                      style="margin: 3px"
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <!-- Preview Body -->
                  <div
                    style="
                      flex-grow: 1;
                      padding: 20px;
                      overflow-y: auto;
                      max-height: 80vh;
                    "
                  >
                    <div
                      style="
                        width: 400px;
                        background-color: #fff0f5;
                        border-radius: 10px;
                        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                      "
                    >
                      <!-- Default image -->
                      <div style="width: 100%; text-align: center">
                        <img
                          id="image"
                          style="
                            border-top-left-radius: 6px;
                            border-top-right-radius: 6px;
                          "
                          src="../../../assets/img/dependent_illness.png"
                          width="100%"
                        />
                      </div>

                      <!-- Rendered Quill content -->
                      <div
                        style="margin-top: -5px"
                        class="ql-editor"
                        [innerHTML]="product.productDetails.productResourceHTML"
                      ></div>
                    </div>
                  </div>

                  <!-- Footer -->
                  <div
                    style="
                      padding: 10px 16px;
                      display: flex;
                      justify-content: flex-end;
                      gap: 10px;
                    "
                  >
                    <button
                      style="
                        padding: 6px 20px;
                        background-color: #142a49;
                        border: 1px solid #4883f2;
                        border-radius: 10px;
                        color: white;
                        font-size: 14px;
                        font-weight: 500;
                        cursor: pointer;
                      "
                      (click)="onProductPreviewClosePopup()"
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Vendor Invoicing and payments -->

            <!-- Vendor Invoicing and payments -->
          </div>
          <!-- Forth Row -->
          <!-- heading of Pricing -->
          <div style="width: 100%">
            <div
              class="header-height"
              style="
                width: 100%;
                background: #142a49;
                color: white;
                border-top: 1px solid #ddd;
              "
            >
              <label
                class="headingFontSize"
                style="margin-left: 15px; background-color: #142a49"
              >
                {{ lang.Pricing }}&nbsp;<i class="bi bi-info-circle"></i>
              </label>
            </div>
            <!-- Container to hold both questions in a row -->
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 20px;
                padding: 10px 0;
                padding-left: 15px;
              "
            >
              <!-- Base Unit -->
              <!-- Base Unit Value Dropdown -->
              <!-- Question 1: Is Base Amount? -->
              <div style="display: flex; align-items: center; gap: 20px">
                <!-- Is Base Amount? -->
                <div style="display: flex; align-items: center; gap: 10px">
                  <label class="fontSize">Base Amount Applicable?</label>

                  <div style="display: flex; gap: 15px; align-items: center">
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="isBaseAmount"
                        [(ngModel)]="product.pricing.isBaseAmountApplicable"
                        [value]="true"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>

                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="isBaseAmount"
                        [(ngModel)]="product.pricing.isBaseAmountApplicable"
                        [value]="false"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>
                </div>

                <!-- Base Unit Value Dropdown (visible only when true) -->
                <div
                  *ngIf="product.pricing.isBaseAmountApplicable"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    min-width: 150px;
                  "
                >
                  <ng-multiselect-dropdown
                    [placeholder]="'Select base unit'"
                    [settings]="{
                      singleSelection: true,
                      idField: 'id',
                      textField: 'value',
                      allowSearchFilter: false,
                      allowRemoteDataSearch: false,
                      enableCheckAll: false
                    }"
                    [data]="baseUnitValues"
                    (onSelect)="onSelectBaseUnit($event)"
                    (onDeSelect)="onDeselectonBaseUnit($event)"
                    [(ngModel)]="product.pricing.baseAmount"
                    [ngModelOptions]="{ standalone: true }"
                    style="font-size: 11px; min-width: 130px"
                  >
                  </ng-multiselect-dropdown>
                  <!--show other input for base unit  -->
                  <div
                    *ngIf="product.pricing.showOtherInputForBaseUnit"
                    style="flex: 1 1 13%; max-width: 120px"
                  >
                    <input
                      type="text"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="product.pricing.otherInputForBaseUnit"
                      placeholder="Enter New Base Unit"
                      style="
                        width: 100%;
                        height: 30px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      (input)="formatCurrency($event)"
                      (blur)="ensureDollar($event)"
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />
                  </div>
                </div>
              </div>

              <!-- Question 2 -->
              <div style="display: flex; align-items: center; gap: 20px">
                <div style="display: flex; align-items: center; gap: 10px">
                  <label class="fontSize">Is price inclusive of tax?</label>

                  <div style="display: flex; gap: 15px; align-items: center">
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="inclusiveTax"
                        [(ngModel)]="product.pricing.isPriceInclusiveOfTax"
                        [value]="true"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>

                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="inclusiveTax"
                        [(ngModel)]="product.pricing.isPriceInclusiveOfTax"
                        [value]="false"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>
              <!-- Question 1 -->
              <div style="display: flex; align-items: center; gap: 20px">
                <!-- Are taxes applicable? -->
                <div style="display: flex; align-items: center; gap: 10px">
                  <label class="fontSize">Is Tax Applicable?</label>

                  <div style="display: flex; gap: 15px; align-items: center">
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="taxApplicable"
                        [(ngModel)]="product.pricing.isTaxApplicable"
                        [value]="true"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>

                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="taxApplicable"
                        [(ngModel)]="product.pricing.isTaxApplicable"
                        [value]="false"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>
                </div>

                <!-- Tax Type checkboxes -->
                <div
                  *ngIf="product.pricing.isTaxApplicable"
                  style="display: flex; align-items: center; gap: 15px"
                >
                  <label style="font-size: 14px">Tax Type</label>

                  <label
                    style="
                      display: flex;
                      align-items: center;
                      font-size: 13px;
                      gap: 5px;
                    "
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="product.pricing.taxTypes.hst"
                      style="cursor: pointer"
                    />
                    HST/GST
                  </label>

                  <label
                    style="
                      display: flex;
                      align-items: center;
                      font-size: 13px;
                      gap: 5px;
                    "
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="product.pricing.taxTypes.pst"
                      style="cursor: pointer"
                    />
                    PST
                  </label>
                </div>
              </div>
            </div>

            <!-- Five Table -->
            <div
              class="pricing_section"
              style="width: 100%; display: flex; column-gap: 10px"
            >
              <!-- Pricing  -->
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  text-align: center;
                "
              >
                <!-- heading of Pricing Areas -->
                <div
                  class="header-height"
                  style="
                    width: 100%;
                    background: #142a49;
                    color: white;
                    border-top: 1px solid #ddd;
                    /* border-radius: 6px 6px 0 0; */
                  "
                >
                  <label
                    class="headingFontSize"
                    style="
                      margin-left: 15px;
                      background-color: #142a49;
                      text-align: center;
                    "
                  >
                    Pricing Areas
                  </label>
                </div>
                <!-- action and level input -->
                <div
                  style="
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding: 5px;
                    padding-left: 15px;
                    align-items: flex-start;
                  "
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      gap: 20px;
                      min-width: 300px;
                      margin-top: 7px;
                    "
                  >
                    <label class="fontSize">No of Zones</label>
                    <!-- Levels Input -->
                    <input
                      type="number"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="product.areas.noOfAreas"
                      (ngModelChange)="
                        generatePricingAreaRows(product.areas.noOfAreas)
                      "
                      min="1"
                      max="10"
                      style="
                        width: 40px;
                        height: 25px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />
                  </div>

                  <!-- Table for pricing area -->
                  <!-- Scrollable container -->
                  <table
                    *ngIf="product.areas.noOfAreas > 0"
                    style="
                      font-weight: lighter;
                      width: 100%;
                      border-collapse: collapse;
                      font-family: Arial, sans-serif;
                      font-size: 12px;
                      table-layout: fixed;
                      border: 1px solid #b9b9b9;
                      margin-top: 19.5px;
                    "
                  >
                    <thead>
                      <tr
                        style="
                          background-color: #808285;
                          color: white;
                          height: 34px;
                        "
                      >
                        <th
                          style="
                            text-align: left;
                            padding: 4px 6px;
                            width: 15%;
                            border-right: 1px solid #b9b9b9;
                          "
                        >
                          Area
                        </th>
                        <th
                          style="
                            text-align: left;
                            padding: 4px 6px;
                            width: 30%;
                            border-right: 1px solid #b9b9b9;
                          "
                        >
                          Name
                        </th>
                        <th
                          style="text-align: left; padding: 4px 6px; width: 55%"
                        >
                          Provinces
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        *ngFor="
                          let row of product.areas.areasData;
                          let i = index
                        "
                        style="
                          background-color: #f6f6f6;
                          border-top: 1px solid #b9b9b9;
                          border-bottom: 1px solid #b9b9b9;
                          height: 34px;
                        "
                      >
                        <!-- Area -->
                        <td
                          style="
                            text-align: left;
                            padding: 3px 6px;
                            border-right: 1px solid #b9b9b9;
                            width: 15%;
                          "
                        >
                          <input
                            type="text"
                            disabled
                            [(ngModel)]="product.areas.areasData[i].area"
                            style="
                              width: 100%;
                              border: none;
                              outline: none;
                              background: transparent;
                              font-size: 13px;
                            "
                          />
                        </td>

                        <!-- Name -->
                        <td
                          style="
                            text-align: left;
                            padding: 3px 6px;
                            border-right: 1px solid #b9b9b9;
                            width: 30%;
                          "
                        >
                          <input
                            type="text"
                            [(ngModel)]="product.areas.areasData[i].name"
                            style="
                              width: 100%;
                              border: none;
                              outline: none;
                              background: transparent;
                              font-size: 13px;
                              text-transform: capitalize;
                            "
                          />
                        </td>

                        <!-- Select Areas -->
                        <td
                          style="text-align: left; padding: 3px 6px; width: 55%"
                        >
                          <ng-multiselect-dropdown
                            [placeholder]="'Select'"
                            [settings]="pricingProvincesdropdownSettings"
                            [data]="getAvailableProvinces(i)"
                            [(ngModel)]="
                              product.areas.areasData[i].selectedProvinces
                            "
                            (onSelect)="onPricingProvinceSelect($event, i)"
                            (onDeSelect)="onPricingProvinceDeSelect($event, i)"
                            style="font-size: 11px; min-height: 30px"
                          >
                          </ng-multiselect-dropdown>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Tiered Section -->
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  text-align: center;
                "
              >
                <div
                  class="header-height"
                  style="
                    width: 100%;
                    background: #142a49;
                    color: white;
                    border-top: 1px solid #ddd;
                  "
                >
                  <label class="headingFontSize" style="margin-left: 15px"
                    >Tiers/Age Bands</label
                  >
                </div>

                <!-- First Line: Tiers? and Age Bands? -->
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    gap: 8px;
                    align-items: center;
                    margin-bottom: 10px;
                    margin-left: 10px;
                  "
                >
                  <!-- Tiers -->
                  <div style="display: flex; align-items: center; gap: 6px">
                    <label class="fontSize">Tiers?</label>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="tiered"
                        [(ngModel)]="product.tiers.isTierEnabled"
                        (change)="onTierChange(true)"
                        [value]="true"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="tiered"
                        [(ngModel)]="product.tiers.isTierEnabled"
                        (change)="onTierChange(false)"
                        [value]="false"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>

                  <!-- Age Bands -->
                  <div style="display: flex; align-items: center; gap: 6px">
                    <label class="fontSize">Age Bands?</label>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="product.ageBands.ageBandsData"
                        [(ngModel)]="product.ageBands.isAgeBandEnabled"
                        (change)="onAgeBandChange(true)"
                        [value]="true"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        gap: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="product.ageBands.ageBandsData"
                        [(ngModel)]="product.ageBands.isAgeBandEnableds"
                        (change)="onAgeBandChange(false)"
                        [value]="false"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>
                </div>

                <!-- Second Line: Input fields appear if Yes is selected -->
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: -5px;
                    margin-left: 10px;
                  "
                >
                  <!-- No of Tiers -->
                  <div
                    *ngIf="product.tiers.isTierEnabled"
                    style="display: flex; align-items: center; gap: 10px"
                  >
                    <label style="font-size: 14px">No of Tiers</label>
                    <input
                      type="number"
                      [(ngModel)]="product.tiers.noOfTiers"
                      (ngModelChange)="
                        generateTieredRows(product.tiers.noOfTiers)
                      "
                      [ngModelOptions]="{ standalone: true }"
                      min="1"
                      max="10"
                      style="
                        width: 40px;
                        height: 25px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />
                  </div>

                  <!-- No of Age Bands -->
                  <div
                    *ngIf="product.ageBands.isAgeBandEnabled"
                    style="display: flex; align-items: center; gap: 10px"
                  >
                    <label style="font-size: 14px">No of Age Bands</label>
                    <input
                      type="number"
                      [(ngModel)]="product.ageBands.noOfAgeBands"
                      (ngModelChange)="
                        generateAgeBands(product.ageBands.noOfAgeBands)
                      "
                      [ngModelOptions]="{ standalone: true }"
                      min="1"
                      max="10"
                      style="
                        width: 40px;
                        height: 25px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />
                  </div>
                </div>

                <!-- Tier Table -->
                <div
                  style="
                    padding-left: 10px;
                    padding-right: 5px;
                    padding-bottom: 2px;
                  "
                >
                  <div
                    *ngIf="
                      product.tiers.isTierEnabled && product.tiers.noOfTiers > 0
                    "
                    style="width: 100%; max-width: 800px; margin-top: 5px"
                  >
                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 12px;
                        border: 1px solid #ccc;
                      "
                    >
                      <thead style="background: #808285; color: white">
                        <tr>
                          <th
                            style="
                              padding: 6px;
                              width: 40%;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Tier
                          </th>
                          <th
                            style="
                              padding: 6px;
                              width: 60%;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Tier Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let row of product.tiers.tiersData;
                            let i = index
                          "
                        >
                          <td
                            style="
                              padding: 2px 4px;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            {{ i + 1 }}
                          </td>
                          <td
                            style="
                              padding: 2px 4px;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            <input
                              type="text"
                              [(ngModel)]="product.tiers.tiersData[i].name"
                              style="
                                text-align: center;
                                width: 100%;
                                padding: 2px 4px;
                                font-size: 13px;
                                border: none;
                                outline: none;
                                text-transform: capitalize;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Age Bands Table (Updated Styling to Match Tier Table) -->
                <div
                  *ngIf="product.ageBands.noOfAgeBands > 0"
                  style="
                    padding-left: 10px;
                    padding-right: 5px;
                    padding-bottom: 2px;
                  "
                >
                  <div style="width: 100%; max-width: 800px; margin-top: 5px">
                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 12px;
                        border: 1px solid #ccc;
                      "
                    >
                      <thead style="background: #808285; color: white">
                        <tr>
                          <th
                            style="
                              padding: 6px;
                              width: 33%;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Age Band
                          </th>
                          <th
                            style="
                              padding: 6px;
                              width: 33%;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Start
                          </th>
                          <th
                            style="
                              padding: 6px;
                              width: 34%;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            End
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let row of product.ageBands.ageBandsData;
                            let i = index
                          "
                        >
                          <td
                            style="
                              padding: 2px 4px;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            {{ i + 1 }}
                          </td>
                          <td
                            style="
                              padding: 2px 4px;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            <input
                              type="number"
                              [(ngModel)]="
                                product.ageBands.ageBandsData[i].start
                              "
                              [readonly]="i > 0"
                              style="
                                text-align: center;
                                width: 100%;
                                padding: 2px 4px;
                                font-size: 13px;
                                border: none;
                                outline: none;
                              "
                            />
                          </td>
                          <td
                            style="
                              padding: 2px 4px;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            <input
                              type="number"
                              [(ngModel)]="product.ageBands.ageBandsData[i].end"
                              (keyup)="onEndChange(i)"
                              style="
                                text-align: center;
                                width: 100%;
                                padding: 2px 4px;
                                font-size: 13px;
                                border: none;
                                outline: none;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Variant Section -->
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  text-align: center;
                "
              >
                <div
                  class="header-height"
                  style="
                    background: #142a49;
                    color: white;
                    border-top: 1px solid #ddd;
                  "
                >
                  <label class="headingFontSize" style="margin-left: 15px">
                    Variants
                  </label>
                </div>

                <!-- Toggle and Input -->
                <div
                  style="
                    width: 100%;
                    padding-left: 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 10px">
                    <label class="fontSize">Variants?</label>

                    <div style="display: flex; gap: 15px; align-items: center">
                      <label
                        style="
                          display: flex;
                          align-items: center;
                          font-size: 13px;
                          gap: 5px;
                        "
                      >
                        <input
                          type="radio"
                          name="variants"
                          [(ngModel)]="product.variants.isVariantEnabled"
                          [value]="true"
                          style="cursor: pointer"
                        />
                        Yes
                      </label>

                      <label
                        style="
                          display: flex;
                          align-items: center;
                          font-size: 13px;
                          gap: 5px;
                        "
                      >
                        <input
                          type="radio"
                          name="variants"
                          [(ngModel)]="product.variants.isVariantEnabled"
                          (change)="onVarientChange(false)"
                          [value]="false"
                          style="cursor: pointer"
                        />
                        No
                      </label>
                    </div>
                  </div>

                  <div
                    *ngIf="product.variants.isVariantEnabled"
                    style="display: flex; align-items: center; gap: 10px"
                  >
                    <label style="font-size: 14px">No of Variants</label>
                    <input
                      type="number"
                      [(ngModel)]="product.variants.noOfVariants"
                      (ngModelChange)="
                        generateVariants(product.variants.noOfVariants)
                      "
                      [ngModelOptions]="{ standalone: true }"
                      min="1"
                      max="10"
                      style="
                        width: 40px;
                        height: 25px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />
                  </div>
                </div>

                <!-- Variant Table -->
                <div style="padding-left: 15px; padding-right: 5px">
                  <div
                    *ngIf="
                      product.variants.isVariantEnabled &&
                      product.variants.noOfVariants > 0
                    "
                    style="width: 100%; max-width: 800px; margin-top: 5px"
                  >
                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 12px;
                        border: 1px solid #ccc;
                      "
                    >
                      <thead style="background: #808285; color: white">
                        <tr>
                          <th
                            style="
                              padding: 6px;
                              width: 40%;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Variant
                          </th>
                          <th
                            style="
                              padding: 6px;
                              width: 60%;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let row of product.variants.variantsData;
                            let i = index
                          "
                        >
                          <td
                            style="
                              padding: 2px 4px;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            {{ i + 1 }}
                          </td>
                          <td
                            style="
                              padding: 2px 4px;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            <input
                              type="text"
                              [(ngModel)]="
                                product.variants.variantsData[i].name
                              "
                              style="
                                text-align: center;
                                width: 100%;
                                padding: 2px 4px;
                                font-size: 13px;
                                border: none;
                                outline: none;
                                text-transform: capitalize;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Service Level Section -->
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  text-align: center;
                "
              >
                <div
                  class="header-height"
                  style="
                    background: #142a49;
                    color: white;
                    border-top: 1px solid #ddd;
                  "
                >
                  <label class="headingFontSize" style="margin-left: 15px"
                    >Service Level</label
                  >
                </div>

                <div
                  style="
                    width: 100%;
                    padding-left: 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 10px">
                    <label class="fontSize">Service Level?</label>

                    <div style="display: flex; gap: 15px; align-items: center">
                      <label
                        style="
                          display: flex;
                          align-items: center;
                          font-size: 13px;
                          gap: 5px;
                        "
                      >
                        <input
                          type="radio"
                          name="categories"
                          [(ngModel)]="
                            product.serviceLevel.isServiceLevelEnabled
                          "
                          style="cursor: pointer"
                          [value]="true"
                        />
                        Yes
                      </label>

                      <label
                        style="
                          display: flex;
                          align-items: center;
                          font-size: 13px;
                          gap: 5px;
                        "
                      >
                        <input
                          type="radio"
                          name="categories"
                          [(ngModel)]="
                            product.serviceLevel.isServiceLevelEnabled
                          "
                          (change)="onServiceLevelChange(false)"
                          [value]="false"
                          style="cursor: pointer"
                        />
                        No
                      </label>
                    </div>
                  </div>

                  <div
                    *ngIf="product.serviceLevel.isServiceLevelEnabled"
                    style="display: flex; align-items: center; gap: 10px"
                  >
                    <label style="font-size: 14px">No of Levels</label>
                    <input
                      type="number"
                      [(ngModel)]="product.serviceLevel.noOfServiceLevel"
                      (ngModelChange)="
                        generateCategoryRows(
                          product.serviceLevel.noOfServiceLevel
                        )
                      "
                      [ngModelOptions]="{ standalone: true }"
                      min="1"
                      max="10"
                      style="
                        width: 40px;
                        height: 25px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />
                  </div>
                </div>

                <div style="padding-left: 15px; padding-right: 5px">
                  <div
                    *ngIf="
                      product.serviceLevel.isServiceLevelEnabled &&
                      product.serviceLevel.noOfServiceLevel > 0
                    "
                    style="width: 100%; max-width: 800px; margin-top: 5px"
                  >
                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 12px;
                        border: 1px solid #ccc;
                      "
                    >
                      <thead style="background: #808285; color: white">
                        <tr>
                          <th
                            style="
                              padding: 6px;
                              width: 40%;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Category
                          </th>
                          <th
                            style="
                              padding: 6px;
                              width: 60%;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            Category Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let row of product.serviceLevel.servicesData;
                            let i = index
                          "
                        >
                          <td
                            style="
                              padding: 2px 4px;
                              border-right: 1px solid #ccc;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            {{ i + 1 }}
                          </td>
                          <td
                            style="
                              padding: 2px 4px;
                              border-bottom: 1px solid #ccc;
                            "
                          >
                            <input
                              type="text"
                              [(ngModel)]="
                                product.serviceLevel.servicesData[i].name
                              "
                              style="
                                text-align: center;
                                width: 100%;
                                padding: 2px 4px;
                                font-size: 13px;
                                border: none;
                                outline: none;
                                text-transform: capitalize;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Submit Pricing Data -->
            <div
              style="
                width: 100%;
                text-align: right;
                margin-right: 2px;
                margin-bottom: 2px;
              "
            >
              <div *ngIf="errorsForTable.length > 0" class="error">
                <div *ngFor="let err of errorsForTable">{{ err }}</div>
              </div>
              <button
                class="btn btn-success btn-sm"
                style="
                  font-size: 13px;
                  padding: 4px 12px;
                  border-radius: 4px;
                  background-color: #142a49;
                  color: #fff;
                "
                (click)="showTable()"
              >
                Submit Pricing Data
              </button>
            </div>
          </div>

          <!--*************************************** Fifth row ***************************** -->
          <!-- SignUp Section -->
          <!-- Singup Form Section -->
          <div *ngIf="isProductValidForFirstRow" style="width: 100%">
            <div
              class="header-height"
              style="
                width: 100%;
                background: #142a49;
                color: white;
                border-top: 1px solid #ddd;
              "
            >
              <label
                class="headingFontSize"
                style="margin-left: 15px; background-color: #142a49"
              >
                Signup Sheet&nbsp;<i class="bi bi-info-circle"></i>
              </label>
            </div>
            <div
              style="
                padding-left: 15px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                margin-top: 5px;
              "
            >
              <!-- signup sheet manage -->
              <div
                style="
                  display: flex;
                  align-items: center;
                  gap: 20px;
                  /* margin-bottom: 10px;
                          margin-top: 5px; */
                "
              >
                <!-- Product Type Checkboxes -->
                <div style="display: flex; align-items: center; gap: 10px">
                  <label
                    class="fontSize"
                    style="display: flex; align-items: center; gap: 5px"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="product.signUpData.targets.individual"
                      style="cursor: pointer"
                    />
                    Individual
                  </label>
                  <label
                    class="fontSize"
                    style="display: flex; align-items: center; gap: 5px"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="product.signUpData.targets.corporate"
                      style="cursor: pointer"
                    />
                    Corporate
                  </label>
                </div>

                <!-- Group Plan Radio Buttons -->
                <div
                  class="fontSize"
                  style="display: flex; align-items: center; gap: 10px"
                >
                  <span class="fontSize">Group Plan?</span>
                  <label
                    style="
                      display: flex;
                      align-items: center;
                      gap: 5px;
                      font-size: 13px;
                      margin-right: 5px;
                    "
                  >
                    <input
                      type="radio"
                      name="groupPlan"
                      [(ngModel)]="product.signUpData.targets.isGroupPlan"
                      [value]="true"
                      style="cursor: pointer"
                    />
                    Yes
                  </label>
                  <label
                    style="
                      display: flex;
                      align-items: center;
                      gap: 5px;
                      font-size: 13px;
                    "
                  >
                    <input
                      type="radio"
                      name="groupPlan"
                      [(ngModel)]="product.signUpData.targets.isGroupPlan"
                      [value]="false"
                      style="cursor: pointer"
                    />
                    No
                  </label>
                </div>

                <!-- Min Headcount Input -->
                <div
                  *ngIf="product.signUpData.targets.isGroupPlan"
                  style="
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    width: 100px;
                  "
                >
                  <input
                    type="text"
                    [(ngModel)]="product.signUpData.targets.minHeadcount"
                    min="1"
                    [ngModelOptions]="{ standalone: true }"
                    (keydown)="validateInteger($event)"
                    (paste)="validatePaste($event)"
                    placeholder="Min headcount"
                    style="
                      width: 1;
                      height: 30px;
                      padding: 6px 10px;
                      font-size: 14px;
                      border: 1px solid #ccc;
                      border-radius: 6px;
                      outline: none;
                      background-color: #e8eaf0;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                      transition: box-shadow 0.2s ease, border-color 0.2s ease;
                    "
                    onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                    onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                  />
                </div>
              </div>
              <!-- dropdown for template -->
              <div style="display: flex; column-gap: 10px">
                <div style="max-width: 220px">
                  <label
                    class="fontSize"
                    style="margin-bottom: 4px; display: block"
                    >Select applicable signup template</label
                  >
                  <ng-multiselect-dropdown
                    [placeholder]="'Select template'"
                    [settings]="templateDropdownSettings"
                    [data]="signupTemplates"
                    [(ngModel)]="product.signUpData.template.selected"
                    (onSelect)="onTemplateSelect($event)"
                    style="
                      font-size: 13px;
                      outline: none;
                      background-color: #e8eaf0;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                      transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      text-transform: capitalize;
                    "
                    onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                    onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                  >
                  </ng-multiselect-dropdown>
                </div>
                <p
                  *ngIf="product.signUpData.template.fields.length > 0"
                  style="margin: 0; font-size: 14px; display: block"
                >
                  Selected Fields: {{ getActiveCount() }}
                </p>
              </div>
            </div>
          </div>

          <!--Manage Signup Popup -->
          <div
            *ngIf="showPopups"
            class="modal fade show d-block"
            data-bs-backdrop="static"
            tabindex="-1"
            style="background: rgba(0, 0, 0, 0.5)"
          >
            <div
              style="width: 50%; max-height: 400px; overflow-y: auto"
              class="modal-dialog modal-lg modal-dialog-centered"
            >
              <div class="modal-content">
                <!-- Header -->
                <div
                  class="header-height"
                  style="
                    background-color: #5d7c9b;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 15px;
                  "
                >
                  <h6
                    class="fontSize"
                    style="background-color: #5d7c9b; color: white; margin: 0"
                  >
                    Signup Form Fields
                  </h6>
                  <button
                    (click)="onCancel()"
                    style="margin: 3px"
                    type="button"
                    class="btn-close"
                  ></button>
                </div>

                <!-- Body -->
                <div style="padding: 15px">
                  <!-- Input Section -->
                  <div style="display: flex; gap: 10px; margin-bottom: 15px">
                    <div style="max-width: 160px">
                      <label class="fontSize">Field Name</label>
                      <input
                        type="text"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="fieldName"
                        placeholder="Field Name"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                          text-transform: capitalize;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                    </div>
                    <div style="flex: 1 1 13%; min-width: 160px">
                      <label class="fontSize">Select Type</label>
                      <ng-multiselect-dropdown
                        [placeholder]="'Select'"
                        [settings]="countryDropdownSettings"
                        [data]="fieldTypes"
                        [(ngModel)]="signUpFieldType"
                        style="
                          font-size: 11px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                          text-transform: capitalize;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      >
                      </ng-multiselect-dropdown>
                    </div>
                    <div style="max-width: 160px">
                      <label class="fontSize">Field Rules</label>
                      <input
                        type="text"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="fieldRules"
                        placeholder="Field Name"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                          text-transform: capitalize;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                    </div>
                    <button
                      class="btn btn-sm fontSize"
                      style="
                        font-size: 14px;
                        height: 30px;
                        padding: 0 10px;
                        border-radius: 4px;
                        background-color: #142a49;
                        border: 1px solid #142a49;
                        color: #ffffff;
                        cursor: pointer;
                        margin-top: 23px;
                      "
                      (click)="addField()"
                    >
                      Add
                    </button>
                  </div>

                  <!-- List Section -->
                  <!-- List Section -->
                  <!-- List Section -->
                  <div
                    style="
                      max-height: 250px;
                      overflow-y: auto;
                      border: 1px solid #ddd;
                      padding: 10px;
                      border-radius: 4px;
                      margin-top: -5px; /* Closer to Add section */
                    "
                  >
                    <div
                      *ngFor="let field of tempForSignupSheet; let i = index"
                      style="
                        display: flex;
                        gap: 10px;
                        align-items: center;
                        margin-bottom: 8px;
                      "
                    >
                      <!-- Checkbox -->
                      <input type="checkbox" [(ngModel)]="field.active" />

                      <!-- Field Name -->
                      <div style="max-width: 160px">
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="field.name"
                          placeholder="Field Name"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                          "
                        />
                      </div>

                      <!-- Select Type -->
                      <div style="flex: 1 1 13%; min-width: 160px">
                        <ng-multiselect-dropdown
                          [placeholder]="'Select'"
                          [settings]="countryDropdownSettings"
                          [data]="fieldTypes"
                          [(ngModel)]="field.type"
                          style="font-size: 11px; background-color: #e8eaf0"
                        ></ng-multiselect-dropdown>
                      </div>

                      <!-- Field Rules -->
                      <div style="max-width: 160px">
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="field.rules"
                          placeholder="Field Rules"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                          "
                        />
                      </div>

                      <!-- Delete Button -->
                      <button
                        (click)="deleteField(i)"
                        style="
                          background-color: #6b1004;
                          border: none;
                          border-radius: 6px;
                          cursor: pointer;
                          margin-top: 0;
                          color: white;
                          padding: 2px 8px;
                          font-size: 12px;
                        "
                      >
                        <i class="bi bi-trash-fill"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Footer -->
                <div
                  class="modal-footer"
                  style="
                    padding: 10px 15px;
                    justify-content: flex-end;
                    gap: 10px;
                  "
                >
                  <!-- Reset -->
                  <button
                    *ngIf="
                      product.signUpData.template.selected.text !==
                      'New template'
                    "
                    class="btn btn-sm fontSize"
                    style="
                      font-size: 14px;
                      padding: 4px 12px;
                      border-radius: 4px;
                      background-color: white;
                      border: 1px solid #142a49;
                      color: #142a49;
                      cursor: pointer;
                    "
                    (click)="onReset()"
                  >
                    Reset
                  </button>
                  <!-- Cancel -->
                  <button
                    class="btn btn-sm fontSize"
                    style="
                      font-size: 14px;
                      padding: 4px 12px;
                      border-radius: 4px;
                      background-color: white;
                      border: 1px solid #142a49;
                      color: #142a49;
                      cursor: pointer;
                    "
                    (click)="onCancel()"
                  >
                    Cancel
                  </button>
                  <!--Save Product Button  -->
                  <button
                    *ngIf="tempForSignupSheet.length > 0"
                    class="btn btn-sm fontSize"
                    style="
                      font-size: 14px;
                      padding: 4px 12px;
                      border-radius: 4px;
                      background-color: #142a49;
                      color: white;
                      cursor: pointer;
                      border: 1px solid #142a49;
                    "
                    (click)="onSaveSignupSheet()"
                  >
                    {{ replaceSaveName }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- *********************************** Six row *********************************** -->
          <!-- Provisioning and Reporting -->
          <div *ngIf="isProductValidForFirstRow" style="width: 100%">
            <div
              class="header-height"
              style="
                width: 100%;
                background: #142a49;
                color: white;
                border-top: 1px solid #ddd;
              "
            >
              <label
                class="headingFontSize"
                style="margin-left: 15px; background-color: #142a49"
              >
                Provisioning And Reporting&nbsp;<i
                  class="bi bi-info-circle"
                ></i>
              </label>
            </div>
            <div style="padding-top: 5px; padding-left: 15px">
              <div class="section-body">
                <!-- Provisioning -->
                <div style="display: flex; gap: 10px">
                  <div class="fontSize">Provisioning?</div>
                  <div style="display: flex; gap: 10px; align-items: center">
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        font-size: 13px;
                      "
                    >
                      <input
                        type="radio"
                        name="prov"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning.enabled
                        "
                        [value]="true"
                        [ngModelOptions]="{ standalone: true }"
                      />
                      Yes
                    </label>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        font-size: 13px;
                      "
                    >
                      <input
                        type="radio"
                        name="prov"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning.enabled
                        "
                        [value]="false"
                        [ngModelOptions]="{ standalone: true }"
                      />
                      No
                    </label>
                  </div>
                  <div
                    *ngIf="
                      product.provisioningAndReporting.provisioning.enabled
                    "
                    style="display: flex; align-items: center; column-gap: 10px"
                  >
                    <div class="fontSize">Interfaces</div>
                    <label
                      style="display: flex; align-items: center; gap: 5px"
                      class="radio-group"
                    >
                      <input
                        type="checkbox"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.enabled
                        "
                        [ngModelOptions]="{ standalone: true }"
                      />
                      Web Interface
                    </label>
                    <label
                      style="display: flex; align-items: center; gap: 5px"
                      class="radio-group"
                    >
                      <input
                        type="checkbox"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.api.enabled
                        "
                        [ngModelOptions]="{ standalone: true }"
                      />
                      API
                    </label>
                  </div>
                </div>

                <div
                  *ngIf="product.provisioningAndReporting.provisioning.enabled"
                  class="sub-section"
                  style="display: flex; flex-direction: column; row-gap: 5px"
                >
                  <!-- Web Interface Block -->
                  <div
                    *ngIf="
                      product.provisioningAndReporting.provisioning.interfaces
                        .web.enabled
                    "
                    class="block"
                  >
                    <div class="row">
                      <div class="fontSize">Sandbox available?</div>
                      <div class="radio-group">
                        <label
                          ><input
                            type="radio"
                            name="sandbox"
                            [(ngModel)]="
                              product.provisioningAndReporting.provisioning
                                .interfaces.web.sandboxAvailable
                            "
                            [value]="true"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          Yes</label
                        >
                        <label
                          ><input
                            type="radio"
                            name="sandbox"
                            [(ngModel)]="
                              product.provisioningAndReporting.provisioning
                                .interfaces.web.sandboxAvailable
                            "
                            [value]="false"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          No</label
                        >
                      </div>
                    </div>
                    <!-- Sandbox Environment -->
                    <div
                      *ngIf="
                        product.provisioningAndReporting.provisioning.interfaces
                          .web.sandboxAvailable
                      "
                      class="env-block"
                      style="
                        margin-top: 8px;
                        border-left: 4px solid #eef2f6;
                        padding: 12px;
                        display: grid;
                        grid-template-columns: auto auto auto auto auto auto;
                        gap: 12px;
                        align-items: center;
                      "
                    >
                      <span class="fontSize" style="grid-column: 1/-1"
                        >Sandbox</span
                      >

                      <input
                        type="text"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.sandbox.loginUrl
                        "
                        placeholder="Login URL"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 180px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <input
                        type="text"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.sandbox.username
                        "
                        placeholder="Username"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 180px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <input
                        type="password"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.sandbox.password
                        "
                        placeholder="Password"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 150px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <input
                        type="text"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.sandbox.provisioningUrl
                        "
                        placeholder="Provisioning URL"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 180px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <!-- 2FA Inline -->
                      <div
                        style="
                          display: inline-flex;
                          align-items: center;
                          gap: 8px;
                        "
                      >
                        <span style="font-size: 14px">2FA?</span>
                        <label
                          style="
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            cursor: pointer;
                            font-size: 13px;
                          "
                        >
                          <input
                            type="radio"
                            name="sandbox2fa"
                            [(ngModel)]="
                              product.provisioningAndReporting.provisioning
                                .interfaces.web.sandbox.is2FA
                            "
                            [value]="true"
                            [ngModelOptions]="{ standalone: true }"
                            style="margin: 0"
                          />
                          Yes
                        </label>
                        <label
                          style="
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            cursor: pointer;
                            font-size: 13px;
                          "
                        >
                          <input
                            type="radio"
                            name="sandbox2fa"
                            [(ngModel)]="
                              product.provisioningAndReporting.provisioning
                                .interfaces.web.sandbox.is2FA
                            "
                            [value]="false"
                            [ngModelOptions]="{ standalone: true }"
                            style="margin: 0"
                          />
                          No
                        </label>
                      </div>
                    </div>

                    <!-- Production Environment -->
                    <div
                      class="env-block"
                      style="
                        margin-top: 8px;
                        border-left: 4px solid #eef2f6;
                        padding: 12px;
                        display: grid;
                        grid-template-columns: auto auto auto auto auto auto;
                        gap: 12px;
                        align-items: center;
                      "
                    >
                      <span class="fontSize" style="grid-column: 1/-1"
                        >Production</span
                      >

                      <input
                        type="text"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.prod.loginUrl
                        "
                        placeholder="Login URL"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 180px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <input
                        type="text"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.prod.username
                        "
                        placeholder="Username"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 180px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <input
                        type="password"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.prod.password
                        "
                        placeholder="Password"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 150px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <input
                        type="text"
                        [(ngModel)]="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.prod.provisioningUrl
                        "
                        placeholder="Provisioning URL"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 180px;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        "
                      />

                      <!-- 2FA Inline -->
                      <div
                        style="
                          display: inline-flex;
                          align-items: center;
                          gap: 8px;
                        "
                      >
                        <span style="font-size: 14px">2FA?</span>
                        <label
                          style="
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            cursor: pointer;
                            font-size: 13px;
                          "
                        >
                          <input
                            type="radio"
                            name="prod2fa"
                            [(ngModel)]="
                              product.provisioningAndReporting.provisioning
                                .interfaces.web.prod.is2FA
                            "
                            [value]="true"
                            [ngModelOptions]="{ standalone: true }"
                            style="margin: 0"
                          />
                          Yes
                        </label>
                        <label
                          style="
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            cursor: pointer;
                            font-size: 13px;
                          "
                        >
                          <input
                            type="radio"
                            name="prod2fa"
                            [(ngModel)]="
                              product.provisioningAndReporting.provisioning
                                .interfaces.web.prod.is2FA
                            "
                            [value]="false"
                            [ngModelOptions]="{ standalone: true }"
                            style="margin: 0"
                          />
                          No
                        </label>
                      </div>
                    </div>

                    <!-- Special Fields for Web -->
                    <div class="special-fields">
                      <div
                        style="display: flex; gap: 20px; align-items: center"
                      >
                        <span class="fontSize">
                          Special Fields (Key / Value with condition)
                        </span>
                        <button
                          type="button"
                          class="btn btn-sm fontSize"
                          style="
                            font-size: 14px;
                            padding: 4px 12px;
                            border-radius: 4px;
                            background-color: #142a49;
                            border: 1px solid #142a49;
                            color: #ffffff;
                            border: none;
                            cursor: pointer;
                          "
                          (click)="addFields('web')"
                        >
                          + Add Field
                        </button>
                      </div>

                      <div
                        *ngIf="
                          product.provisioningAndReporting.provisioning
                            .interfaces.web.fields.length
                        "
                        style="width: 100%; max-width: 600px; margin-top: 5px"
                      >
                        <table
                          style="
                            width: 100%;
                            border-collapse: collapse;
                            font-size: 12px;
                            border: 1px solid #ccc;
                          "
                        >
                          <thead style="background: #808285; color: white">
                            <tr>
                              <th
                                style="
                                  padding: 6px;
                                  width: 40%;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                  text-align: center;
                                "
                              >
                                Key
                              </th>
                              <th
                                style="
                                  padding: 6px;
                                  width: 50%;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                  text-align: center;
                                "
                              >
                                Value / Condition
                              </th>
                              <th
                                style="
                                  padding: 6px;
                                  width: 10%;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="
                                let f of product.provisioningAndReporting
                                  .provisioning.interfaces.web.fields;
                                let i = index
                              "
                            >
                              <td
                                style="
                                  padding: 2px 4px;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                <input
                                  type="text"
                                  [(ngModel)]="f.key"
                                  placeholder="Key"
                                  [ngModelOptions]="{
                                    standalone: true
                                  }"
                                  style="
                                    text-align: center;
                                    width: 100%;
                                    padding: 2px 4px;
                                    font-size: 13px;
                                    border: none;
                                    outline: none;
                                  "
                                />
                              </td>
                              <td
                                style="
                                  padding: 2px 4px;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                <input
                                  type="text"
                                  [(ngModel)]="f.value"
                                  placeholder="Value / Condition"
                                  [ngModelOptions]="{
                                    standalone: true
                                  }"
                                  style="
                                    text-align: center;
                                    width: 100%;
                                    padding: 2px 4px;
                                    font-size: 13px;
                                    border: none;
                                    outline: none;
                                  "
                                />
                              </td>
                              <td
                                style="
                                  padding: 2px 4px;
                                  text-align: center;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                <span
                                  (click)="removeField('web', i)"
                                  style="cursor: pointer; color: #b22222"
                                >
                                  <i class="bi bi-trash-fill"></i>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- API Block -->
                  <div
                    *ngIf="
                      product.provisioningAndReporting.provisioning.interfaces
                        .api.enabled
                    "
                    class="block"
                    style="margin-top: 2px"
                  >
                    <input
                      type="text"
                      class="ref-input"
                      [(ngModel)]="
                        product.provisioningAndReporting.provisioning.interfaces
                          .api.apiKey
                      "
                      placeholder="API Key"
                      [ngModelOptions]="{ standalone: true }"
                    />

                    <!-- HTML: API Parameters (keeps variables/functions/text names unchanged) -->
                    <!-- API Parameters -->
                    <div class="special-fields">
                      <div
                        style="display: flex; gap: 20px; align-items: center"
                      >
                        <span class="fontSize">
                          API Parameters (Key / Value with condition)
                        </span>
                        <button
                          type="button"
                          class="btn btn-sm fontSize"
                          style="
                            font-size: 14px;
                            padding: 4px 12px;
                            border-radius: 4px;
                            background-color: #142a49;
                            border: 1px solid #142a49;
                            color: #ffffff;
                            border: none;
                            cursor: pointer;
                          "
                          (click)="addFields('api')"
                        >
                          + Add Field
                        </button>
                      </div>

                      <div
                        *ngIf="
                          product.provisioningAndReporting.provisioning
                            .interfaces.api.fields.length
                        "
                        style="width: 100%; max-width: 600px; margin-top: 5px"
                      >
                        <table
                          style="
                            width: 100%;
                            border-collapse: collapse;
                            font-size: 12px;
                            border: 1px solid #ccc;
                          "
                        >
                          <thead style="background: #808285; color: white">
                            <tr>
                              <th
                                style="
                                  padding: 6px;
                                  width: 40%;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                  text-align: center;
                                "
                              >
                                Key
                              </th>
                              <th
                                style="
                                  padding: 6px;
                                  width: 50%;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                  text-align: center;
                                "
                              >
                                Value / Condition
                              </th>
                              <th
                                style="
                                  padding: 6px;
                                  width: 10%;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="
                                let f of product.provisioningAndReporting
                                  .provisioning.interfaces.api.fields;
                                let i = index
                              "
                            >
                              <td
                                style="
                                  padding: 2px 4px;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                <input
                                  type="text"
                                  [(ngModel)]="f.key"
                                  placeholder="Key"
                                  [ngModelOptions]="{
                                    standalone: true
                                  }"
                                  style="
                                    text-align: center;
                                    width: 100%;
                                    padding: 2px 4px;
                                    font-size: 13px;
                                    border: none;
                                    outline: none;
                                  "
                                />
                              </td>
                              <td
                                style="
                                  padding: 2px 4px;
                                  border-right: 1px solid #ccc;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                <input
                                  type="text"
                                  [(ngModel)]="f.value"
                                  placeholder="Value / Condition"
                                  [ngModelOptions]="{
                                    standalone: true
                                  }"
                                  style="
                                    text-align: center;
                                    width: 100%;
                                    padding: 2px 4px;
                                    font-size: 13px;
                                    border: none;
                                    outline: none;
                                  "
                                />
                              </td>
                              <td
                                style="
                                  padding: 2px 4px;
                                  text-align: center;
                                  border-bottom: 1px solid #ccc;
                                "
                              >
                                <span
                                  (click)="removeField('api', i)"
                                  style="cursor: pointer; color: #b22222"
                                >
                                  <i class="bi bi-trash-fill"></i>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Reporting -->
                <div style="display: flex; align-items: center; gap: 10px">
                  <div
                    class="fontSize"
                    style="display: flex; align-items: center; gap: 10px"
                  >
                    <span class="fontSize">Reporting?</span>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        font-size: 13px;
                        margin-right: 5px;
                      "
                    >
                      <input
                        type="radio"
                        name="report"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.enabled
                        "
                        [value]="true"
                        style="cursor: pointer"
                      />
                      Yes
                    </label>
                    <label
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        font-size: 13px;
                      "
                    >
                      <input
                        type="radio"
                        name="report"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.enabled
                        "
                        [value]="false"
                        style="cursor: pointer"
                      />
                      No
                    </label>
                  </div>
                  <!-- If Reporting -->
                  <ng-container
                    *ngIf="product.provisioningAndReporting.reporting.enabled"
                  >
                    <!-- File Type -->
                    <ng-multiselect-dropdown
                      [placeholder]="'File Type'"
                      [settings]="fileTypeDropdownSettings"
                      [data]="fileTypes"
                      [(ngModel)]="
                        product.provisioningAndReporting.reporting.fileType
                      "
                      [ngModelOptions]="{ standalone: true }"
                      style="
                        width: 220px;
                        font-size: 11px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                        text-transform: capitalize;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    >
                    </ng-multiselect-dropdown>

                    <!-- Frequency -->
                    <ng-multiselect-dropdown
                      [placeholder]="'Frequency'"
                      [settings]="frequencyDropdownSettings"
                      [data]="frequencies"
                      [(ngModel)]="
                        product.provisioningAndReporting.reporting.frequency
                      "
                      [ngModelOptions]="{ standalone: true }"
                      style="
                        width: 220px;
                        font-size: 11px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                        text-transform: capitalize;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    >
                    </ng-multiselect-dropdown>

                    <!-- Due Date -->
                    <input
                      type="number"
                      [(ngModel)]="
                        product.provisioningAndReporting.reporting.dueDate
                      "
                      placeholder="Due day"
                      [ngModelOptions]="{ standalone: true }"
                      style="
                        width: 100px;
                        height: 30px;
                        padding: 6px 10px;
                        font-size: 14px;
                        border: 1px solid #ccc;
                        border-radius: 6px;
                        outline: none;
                        background-color: #e8eaf0;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                        transition: box-shadow 0.2s ease, border-color 0.2s ease;
                      "
                      onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                      onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                    />

                    <!-- Self-billing -->
                    <label class="radio-group fontSize"
                      ><input
                        type="checkbox"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.selfBilling
                            .enabled
                        "
                        [ngModelOptions]="{ standalone: true }"
                      />
                      Self-billing</label
                    >

                    <!-- Census -->
                    <label class="radio-group fontSize"
                      ><input
                        type="checkbox"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.census
                            .enabled
                        "
                        [ngModelOptions]="{ standalone: true }"
                      />
                      Census</label
                    >
                  </ng-container>
                </div>

                <div
                  *ngIf="product.provisioningAndReporting.reporting.enabled"
                  class="sub-section"
                >
                  <!-- Self Billing -->
                  <div
                    *ngIf="
                      product.provisioningAndReporting.reporting.selfBilling
                        .enabled
                    "
                    class="block"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        margin-bottom: 8px;
                      "
                    >
                      <div
                        style="
                          min-width: 130px;
                          font-weight: 500;
                          font-size: 13px;
                        "
                      >
                        Reporting Period
                      </div>
                      <!-- Start Month -->
                      <ng-multiselect-dropdown
                        [placeholder]="'Start Month'"
                        [settings]="{
                          singleSelection: true,
                          allowSearchFilter: false,
                          closeDropDownOnSelection: true,
                          textField: 'name',
                          idField: 'id',
                          maxHeight: 200
                        }"
                        [data]="months"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.selfBilling
                            .startMonth
                        "
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 220px;
                          font-size: 11px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                          text-transform: capitalize;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      >
                      </ng-multiselect-dropdown>

                      <!-- End Month -->
                      <ng-multiselect-dropdown
                        [placeholder]="'End Month'"
                        [settings]="{
                          singleSelection: true,
                          allowSearchFilter: false,
                          closeDropDownOnSelection: true,
                          textField: 'name',
                          idField: 'id',
                          maxHeight: 200
                        }"
                        [data]="months"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.selfBilling
                            .endMonth
                        "
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 220px;
                          font-size: 11px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                          text-transform: capitalize;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      >
                      </ng-multiselect-dropdown>
                    </div>

                    <!-- Self-billing Fields -->
                    <div
                      style="
                        display: flex;
                        align-items: flex-start;
                        gap: 20px;
                        width: 100%;
                      "
                    >
                      <div class="special-fields" style="width: 40%">
                        <div
                          style="display: flex; gap: 20px; align-items: center"
                        >
                          <span class="fontSize">
                            Self-billing Fields (Key / Value with condition)
                          </span>
                          <button
                            type="button"
                            class="btn btn-sm fontSize"
                            style="
                              font-size: 14px;
                              padding: 4px 12px;
                              border-radius: 4px;
                              background-color: #142a49;
                              border: 1px solid #142a49;
                              color: #ffffff;
                              border: none;
                              cursor: pointer;
                            "
                            (click)="addFields('self')"
                          >
                            + Add Field
                          </button>
                        </div>

                        <div
                          *ngIf="
                            product.provisioningAndReporting.reporting
                              .selfBilling.fields.length
                          "
                          style="width: 100%; max-width: 600px; margin-top: 5px"
                        >
                          <table
                            style="
                              width: 100%;
                              border-collapse: collapse;
                              font-size: 12px;
                              border: 1px solid #ccc;
                            "
                          >
                            <thead style="background: #808285; color: white">
                              <tr>
                                <th
                                  style="
                                    padding: 6px;
                                    width: 40%;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                    text-align: center;
                                  "
                                >
                                  Key
                                </th>
                                <th
                                  style="
                                    padding: 6px;
                                    width: 50%;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                    text-align: center;
                                  "
                                >
                                  Value / Condition
                                </th>
                                <th
                                  style="
                                    padding: 6px;
                                    width: 10%;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let f of product.provisioningAndReporting
                                    .reporting.selfBilling.fields;
                                  let i = index
                                "
                              >
                                <td
                                  style="
                                    padding: 2px 4px;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  <input
                                    type="text"
                                    [(ngModel)]="f.key"
                                    placeholder="Key"
                                    [ngModelOptions]="{
                                      standalone: true
                                    }"
                                    style="
                                      text-align: center;
                                      width: 100%;
                                      padding: 2px 4px;
                                      font-size: 13px;
                                      border: none;
                                      outline: none;
                                    "
                                  />
                                </td>
                                <td
                                  style="
                                    padding: 2px 4px;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  <input
                                    type="text"
                                    [(ngModel)]="f.value"
                                    placeholder="Value / Condition"
                                    [ngModelOptions]="{
                                      standalone: true
                                    }"
                                    style="
                                      text-align: center;
                                      width: 100%;
                                      padding: 2px 4px;
                                      font-size: 13px;
                                      border: none;
                                      outline: none;
                                    "
                                  />
                                </td>
                                <td
                                  style="
                                    padding: 2px 4px;
                                    text-align: center;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  <span
                                    (click)="removeField('self', i)"
                                    style="cursor: pointer; color: #b22222"
                                  >
                                    <i class="bi bi-trash-fill"></i>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!-- Divider -->
                      <div
                        style="
                          width: 1px;
                          background-color: #ccc;
                          box-shadow: 1px 0 3px rgba(0, 0, 0, 0.1);
                        "
                      ></div>
                      <!-- Census Fields -->
                      <div
                        *ngIf="
                          product.provisioningAndReporting.reporting.census
                            .enabled
                        "
                        class="special-fields"
                        style="width: 40%"
                      >
                        <div
                          style="display: flex; gap: 20px; align-items: center"
                        >
                          <span class="fontSize">
                            Census Fields (Key / Value with condition)
                          </span>
                          <button
                            type="button"
                            class="btn btn-sm fontSize"
                            style="
                              font-size: 14px;
                              padding: 4px 12px;
                              border-radius: 4px;
                              background-color: #142a49;
                              border: 1px solid #142a49;
                              color: #ffffff;
                              border: none;
                              cursor: pointer;
                            "
                            (click)="addFields('census')"
                          >
                            + Add Field
                          </button>
                        </div>

                        <div
                          *ngIf="
                            product.provisioningAndReporting.reporting.census
                              .fields.length
                          "
                          style="width: 100%; max-width: 600px; margin-top: 5px"
                        >
                          <table
                            style="
                              width: 100%;
                              border-collapse: collapse;
                              font-size: 12px;
                              border: 1px solid #ccc;
                            "
                          >
                            <thead style="background: #808285; color: white">
                              <tr>
                                <th
                                  style="
                                    padding: 6px;
                                    width: 40%;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                    text-align: center;
                                  "
                                >
                                  Key
                                </th>
                                <th
                                  style="
                                    padding: 6px;
                                    width: 50%;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                    text-align: center;
                                  "
                                >
                                  Value / Condition
                                </th>
                                <th
                                  style="
                                    padding: 6px;
                                    width: 10%;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let f of product.provisioningAndReporting
                                    .reporting.census.fields;
                                  let i = index
                                "
                              >
                                <td
                                  style="
                                    padding: 2px 4px;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  <input
                                    type="text"
                                    [(ngModel)]="f.key"
                                    placeholder="Key"
                                    [ngModelOptions]="{
                                      standalone: true
                                    }"
                                    style="
                                      text-align: center;
                                      width: 100%;
                                      padding: 2px 4px;
                                      font-size: 13px;
                                      border: none;
                                      outline: none;
                                    "
                                  />
                                </td>
                                <td
                                  style="
                                    padding: 2px 4px;
                                    border-right: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  <input
                                    type="text"
                                    [(ngModel)]="f.value"
                                    placeholder="Value / Condition"
                                    [ngModelOptions]="{
                                      standalone: true
                                    }"
                                    style="
                                      text-align: center;
                                      width: 100%;
                                      padding: 2px 4px;
                                      font-size: 13px;
                                      border: none;
                                      outline: none;
                                    "
                                  />
                                </td>
                                <td
                                  style="
                                    padding: 2px 4px;
                                    text-align: center;
                                    border-bottom: 1px solid #ccc;
                                  "
                                >
                                  <span
                                    (click)="removeField('census', i)"
                                    style="cursor: pointer; color: #b22222"
                                  >
                                    <i class="bi bi-trash-fill"></i>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Both Self-billing and Census -->
                  <div
                    *ngIf="
                      product.provisioningAndReporting.reporting.selfBilling
                        .enabled &&
                      product.provisioningAndReporting.reporting.census.enabled
                    "
                    class="block"
                    style="display: flex"
                  >
                    <div class="row">
                      <label class="fontSize">
                        Combine into single file?
                      </label>
                      <div class="radio-group">
                        <label
                          ><input
                            type="radio"
                            name="combine"
                            [(ngModel)]="
                              product.provisioningAndReporting.reporting
                                .combineReports
                            "
                            [value]="true"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          Yes</label
                        >
                        <label
                          ><input
                            type="radio"
                            name="combine"
                            [(ngModel)]="
                              product.provisioningAndReporting.reporting
                                .combineReports
                            "
                            [value]="false"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          No</label
                        >
                      </div>
                    </div>

                    <div class="row">
                      <label class="fontSize"> Maintain Census History? </label>
                      <div class="radio-group">
                        <label
                          ><input
                            type="radio"
                            name="history"
                            [(ngModel)]="
                              product.provisioningAndReporting.reporting
                                .maintainHistory
                            "
                            [value]="true"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          Yes</label
                        >
                        <label
                          ><input
                            type="radio"
                            name="history"
                            [(ngModel)]="
                              product.provisioningAndReporting.reporting
                                .maintainHistory
                            "
                            [value]="false"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          No</label
                        >
                      </div>
                    </div>
                    <div>
                      <label class="fontSize">Compile vs Separate?</label>
                      <ng-multiselect-dropdown
                        [placeholder]="'Select Mode'"
                        [settings]="{
                          singleSelection: true,
                          allowSearchFilter: false,
                          closeDropDownOnSelection: true,
                          textField: 'name',
                          idField: 'id',
                          maxHeight: 200
                        }"
                        [data]="[
                          { id: 'compile', name: 'Compile' },
                          { id: 'separate', name: 'Separate' }
                        ]"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.compileMode
                        "
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          font-size: 11px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                          text-transform: capitalize;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      >
                      </ng-multiselect-dropdown>
                    </div>
                  </div>

                  <!-- Delivery -->
                  <div
                    class="block"
                    style="
                      display: flex;
                      align-items: center;
                      gap: 10px;
                      flex-wrap: nowrap;
                    "
                  >
                    <!-- Delivery Method Dropdown -->
                    <div style="display: flex; align-items: center; gap: 10px">
                      <div class="fontSize">Delivery Method</div>
                      <ng-multiselect-dropdown
                        [placeholder]="'Select Delivery Method'"
                        [settings]="{
                          singleSelection: true,
                          allowSearchFilter: false,
                          closeDropDownOnSelection: true,
                          textField: 'name',
                          idField: 'id',
                          maxHeight: 200
                        }"
                        [data]="[
                          { id: 'email', name: 'Email' },
                          { id: 'sftp', name: 'SFTP / Website' }
                        ]"
                        [(ngModel)]="
                          product.provisioningAndReporting.reporting.delivery
                            .method
                        "
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          width: 200px;
                          font-size: 11px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                          text-transform: capitalize;
                        "
                        (focus)="
                          this.style.boxShadow = '0 2px 6px rgba(0,0,0,0.12)';
                          this.style.borderColor = '#6c757d'
                        "
                        (blur)="
                          this.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
                          this.style.borderColor = '#ccc'
                        "
                      ></ng-multiselect-dropdown>
                    </div>

                    <!-- Email Input -->
                    <input
                      *ngIf="
                        product.provisioningAndReporting.reporting.delivery
                          .method &&
                        product.provisioningAndReporting.reporting.delivery
                          .method.length &&
                        product.provisioningAndReporting.reporting.delivery
                          .method[0].name === 'Email'
                      "
                      class="ref-input"
                      type="text"
                      [(ngModel)]="
                        product.provisioningAndReporting.reporting.delivery
                          .emailRecipients
                      "
                      placeholder="Recipients (comma separated)"
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 250px; font-size: 11px"
                    />

                    <!-- SFTP Inputs -->
                    <input
                      *ngIf="
                        product.provisioningAndReporting.reporting.delivery
                          .method &&
                        product.provisioningAndReporting.reporting.delivery
                          .method.length &&
                        product.provisioningAndReporting.reporting.delivery
                          .method[0].name === 'SFTP / Website'
                      "
                      class="ref-input"
                      type="text"
                      [(ngModel)]="
                        product.provisioningAndReporting.reporting.delivery
                          .sftpHost
                      "
                      placeholder="SFTP Host"
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 150px; font-size: 11px"
                    />
                    <input
                      *ngIf="
                        product.provisioningAndReporting.reporting.delivery
                          .method &&
                        product.provisioningAndReporting.reporting.delivery
                          .method.length &&
                        product.provisioningAndReporting.reporting.delivery
                          .method[0].name === 'SFTP / Website'
                      "
                      class="ref-input"
                      type="text"
                      [(ngModel)]="
                        product.provisioningAndReporting.reporting.delivery
                          .sftpPath
                      "
                      placeholder="Path"
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 150px; font-size: 11px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ******************************** Seven Row******************************** -->
          <!-- Showing Tables for Pricing  -->
          <div *ngIf="product.pricing.showPricingTable" style="width: 100%">
            <!-- heading of Pricing Data -->
            <div
              class="header-height"
              style="
                width: 100%;
                background: #142a49;
                color: white;
                border-top: 1px solid #ddd;
              "
            >
              <label
                class="headingFontSize"
                style="
                  margin: 0;
                  background-color: #142a49;
                  text-align: center;
                  padding-left: 15px;
                "
              >
                Pricing Data&nbsp;<i class="bi bi-info-circle"></i>
              </label>
            </div>
            <!-- Advisor Comission and TPA Comission and other fees -->
            <!-- Advisor Comission and TPA Comission and other fees -->
            <div
              *ngIf="isProductValidForFirstRow"
              style="
                padding-left: 15px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 12px;
              "
            >
              <!-- Advisor Commission -->
              <div style="max-width: 160px">
                <label class="fontSize">Advisor Commission</label>
                <input
                  type="text"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="product.pricing.advisorCommission"
                  placeholder="Advisor Commission"
                  style="
                    width: 100%;
                    height: 30px;
                    padding: 6px 10px;
                    font-size: 14px;
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    outline: none;
                    background-color: #e8eaf0;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                    transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  "
                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                />
                <div style="display: flex; align-items: center; gap: 10px">
                  <label>
                    <input
                      type="radio"
                      name="advisorType"
                      value="$"
                      [(ngModel)]="product.pricing.advisorCommissionType"
                    />
                    $
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="advisorType"
                      value="%"
                      [(ngModel)]="product.pricing.advisorCommissionType"
                    />
                    %
                  </label>
                </div>
              </div>

              <!-- TPA Commission -->
              <div style="max-width: 160px">
                <label class="fontSize">TPA Commission</label>
                <input
                  type="number"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="product.pricing.tpaCommission"
                  placeholder="TPA Commission"
                  style="
                    width: 100%;
                    height: 30px;
                    padding: 6px 10px;
                    font-size: 14px;
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    outline: none;
                    background-color: #e8eaf0;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                    transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  "
                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                />
                <div style="display: flex; align-items: center; gap: 10px">
                  <label>
                    <input
                      type="radio"
                      name="tpaType"
                      value="$"
                      [(ngModel)]="product.pricing.tpaCommissionType"
                    />
                    $
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="tpaType"
                      value="%"
                      [(ngModel)]="product.pricing.tpaCommissionType"
                    />
                    %
                  </label>
                </div>
              </div>

              <!-- Other Fees -->
              <div style="max-width: 160px">
                <label class="fontSize">Other Fees</label>
                <input
                  type="number"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="product.pricing.otherFees"
                  placeholder="Other Fees"
                  style="
                    width: 100%;
                    height: 30px;
                    padding: 6px 10px;
                    font-size: 14px;
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    outline: none;
                    background-color: #e8eaf0;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                    transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  "
                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                />
                <div style="display: flex; align-items: center; gap: 10px">
                  <label>
                    <input
                      type="radio"
                      name="otherFeesType"
                      value="$"
                      [(ngModel)]="product.pricing.otherFeesType"
                    />
                    $
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="otherFeesType"
                      value="%"
                      [(ngModel)]="product.pricing.otherFeesType"
                    />
                    %
                  </label>
                </div>
              </div>
              <!-- Unit Price -->
              <div style="max-width: 160px">
                <label class="fontSize">Unit Price</label>
                <input
                  type="number"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="product.pricing.unitPrice"
                  placeholder="Unit Price"
                  style="
                    width: 100%;
                    height: 30px;
                    padding: 6px 10px;
                    font-size: 14px;
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    outline: none;
                    background-color: #e8eaf0;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                    transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  "
                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                />
                <div style="display: flex; align-items: center; gap: 10px">
                  <label>
                    <input
                      type="radio"
                      name="unit"
                      value="$"
                      [(ngModel)]="product.pricing.unitPriceType"
                    />
                    $
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="unit"
                      value="%"
                      [(ngModel)]="product.pricing.unitPriceType"
                    />
                    %
                  </label>
                </div>
              </div>
              <!-- submit button -->
              <button
                class="btn btn-sm fontSize"
                style="
                  font-size: 14px;
                  height: 30px; /* ✅ match input height */
                  padding: 0 12px; /* ✅ adjust padding to center text */
                  border-radius: 4px; /* match input radius */
                  background-color: #142a49;
                  border: 1px solid #142a49;
                  color: #ffffff;
                  cursor: pointer;
                "
                (click)="showTable()"
              >
                Submit
              </button>
            </div>
            <!-- showing all tables auto -->
            <!-- Condition 0: -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'default'
              "
            >
              <h4 class="pricing-first-heading">Pricing: Default</h4>
              <h4 class="pricing-first-heading">Pricing: Default</h4>

              <table
                style="width: 100%; border-collapse: collapse; font-size: 13px"
              >
                <thead style="background-color: #808285; color: white">
                  <tr>
                    <th style="padding: 6px; border: 1px solid #ccc">
                      Unit Price
                    </th>
                    <th style="padding: 6px; border: 1px solid #ccc">
                      Advisor Commission
                    </th>
                    <th style="padding: 6px; border: 1px solid #ccc">
                      TPA Commission
                    </th>
                    <th style="padding: 6px; border: 1px solid #ccc">
                      Other Fees
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="padding: 6px; border: 1px solid #ccc">
                      <input
                        type="text"
                        (keydown)="
                          allowCurrencyOrPercent($event, $event.target['value'])
                        "
                        (paste)="preventInvalidPaste($event)"
                        [ngModel]="
                          getPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'Unit Price'
                          )
                        "
                        (ngModelChange)="
                          setPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'Unit Price',
                            $event
                          )
                        "
                        style="
                          width: 100%;
                          border: none;
                          outline: none;
                          text-align: center;
                        "
                      />
                    </td>
                    <td style="padding: 6px; border: 1px solid #ccc">
                      <input
                        type="text"
                        (keydown)="
                          allowCurrencyOrPercent($event, $event.target['value'])
                        "
                        (paste)="preventInvalidPaste($event)"
                        [ngModel]="
                          getPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'Advisor Commission'
                          )
                        "
                        (ngModelChange)="
                          setPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'Advisor Commission',
                            $event
                          )
                        "
                        style="
                          width: 100%;
                          border: none;
                          outline: none;
                          text-align: center;
                        "
                      />
                    </td>
                    <td style="padding: 6px; border: 1px solid #ccc">
                      <input
                        type="text"
                        (keydown)="
                          allowCurrencyOrPercent($event, $event.target['value'])
                        "
                        (paste)="preventInvalidPaste($event)"
                        [ngModel]="
                          getPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'TPA Commission'
                          )
                        "
                        (ngModelChange)="
                          setPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'TPA Commission',
                            $event
                          )
                        "
                        style="
                          width: 100%;
                          border: none;
                          outline: none;
                          text-align: center;
                        "
                      />
                    </td>
                    <td style="padding: 6px; border: 1px solid #ccc">
                      <input
                        type="text"
                        (keydown)="
                          allowCurrencyOrPercent($event, $event.target['value'])
                        "
                        (paste)="preventInvalidPaste($event)"
                        [ngModel]="
                          getPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'Other Fees'
                          )
                        "
                        (ngModelChange)="
                          setPricingValue(
                            'default',
                            '',
                            '',
                            '',
                            '',
                            'Other Fees',
                            $event
                          )
                        "
                        style="
                          width: 100%;
                          border: none;
                          outline: none;
                          text-align: center;
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
            <!-- pending condition :Zone → Tier → Category -->
            <ng-container
              style="
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-tier-category'
              "
            >
              <h4 class="pricing-first-heading">
                Pricing: Zone → Tier → Category
              </h4>

              <!-- Loop through Zones -->
              <div
                *ngFor="let zone of product.areas.areasData"
                style="margin-bottom: 20px"
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <!-- Horizontal tier table wrapper -->
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    padding-left: 10px;
                    padding-right: 10px;
                  "
                >
                  <div
                    *ngFor="let tier of product.tiers.tiersData"
                    style="
                      width: 32%;
                      min-width: 300px;
                      background: #fff;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);

                      padding: 10px;
                    "
                  >
                    <h6
                      style="margin-left: 150px"
                      class="pricing-third-heading"
                    >
                      Tier: {{ tier.name }}
                    </h6>
                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Category
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let category of product.serviceLevel.servicesData
                          "
                        >
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ category.name }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              placeholder="$100.00"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              placeholder="$100.00"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              placeholder="$100.00"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  category.name,
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 1: zone-only -->
            <ng-container
              style="
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-top: 8px;
              "
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-only'
              "
            >
              <h4 class="pricing-first-heading">Pricing: Zone Only</h4>

              <!-- Loop through Zones -->
              <div
                *ngFor="let zone of product.areas.areasData"
                style="
                  background: #fff;
                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                  padding: 10px;
                  margin-bottom: 20px;
                  width: 100%;
                "
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <table
                  style="
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                  "
                >
                  <thead style="background-color: #808285; color: white">
                    <tr>
                      <th style="padding: 6px; border: 1px solid #ccc">
                        Unit Price
                      </th>
                      <th style="padding: 6px; border: 1px solid #ccc">
                        Advisor Commission
                      </th>
                      <th style="padding: 6px; border: 1px solid #ccc">
                        TPA Commission
                      </th>
                      <th style="padding: 6px; border: 1px solid #ccc">
                        Other Fees
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="padding: 6px; border: 1px solid #ccc">
                        <input
                          type="text"
                          (keydown)="
                            allowCurrencyOrPercent(
                              $event,
                              $event.target['value']
                            )
                          "
                          (paste)="preventInvalidPaste($event)"
                          [ngModel]="
                            getPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'Unit Price'
                            )
                          "
                          (ngModelChange)="
                            setPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'Unit Price',
                              $event
                            )
                          "
                          style="
                            width: 100%;
                            border: none;
                            outline: none;
                            text-align: center;
                          "
                        />
                      </td>

                      <td style="padding: 6px; border: 1px solid #ccc">
                        <input
                          type="text"
                          (keydown)="
                            allowCurrencyOrPercent(
                              $event,
                              $event.target['value']
                            )
                          "
                          (paste)="preventInvalidPaste($event)"
                          [ngModel]="
                            getPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'Advisor Commission'
                            )
                          "
                          (ngModelChange)="
                            setPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'Advisor Commission',
                              $event
                            )
                          "
                          style="
                            width: 100%;
                            border: none;
                            outline: none;
                            text-align: center;
                          "
                        />
                      </td>

                      <td style="padding: 6px; border: 1px solid #ccc">
                        <input
                          type="text"
                          (keydown)="
                            allowCurrencyOrPercent(
                              $event,
                              $event.target['value']
                            )
                          "
                          (paste)="preventInvalidPaste($event)"
                          [ngModel]="
                            getPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'TPA Commission'
                            )
                          "
                          (ngModelChange)="
                            setPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'TPA Commission',
                              $event
                            )
                          "
                          style="
                            width: 100%;
                            border: none;
                            outline: none;
                            text-align: center;
                          "
                        />
                      </td>

                      <td style="padding: 6px; border: 1px solid #ccc">
                        <input
                          type="text"
                          (keydown)="
                            allowCurrencyOrPercent(
                              $event,
                              $event.target['value']
                            )
                          "
                          (paste)="preventInvalidPaste($event)"
                          [ngModel]="
                            getPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'Other Fees'
                            )
                          "
                          (ngModelChange)="
                            setPricingValue(
                              zone.name,
                              '',
                              '',
                              '',
                              '',
                              'Other Fees',
                              $event
                            )
                          "
                          style="
                            width: 100%;
                            border: none;
                            outline: none;
                            text-align: center;
                          "
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>

            <!-- Condition 2: Zone + Tier -->
            <div
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-tier'
              "
              style="
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <h4 class="pricing-first-heading">Pricing: Zone → Tier</h4>

              <!-- Wrapper for all zones -->
              <div style="display: flex; flex-wrap: wrap; gap: 20px">
                <div
                  *ngFor="let zone of product.areas.areasData"
                  style="flex: 1 1 calc(33.333% - 20px); box-sizing: border-box"
                >
                  <div
                    style="
                      background: #fff;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                      padding: 10px;
                      margin-top: 10px;
                      width: 100%;
                    "
                  >
                    <!-- Zone heading moved inside white box -->
                    <h5
                      style="
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        font-weight: 500;
                        font-size: 14px;
                        border-radius: 2px;
                        padding: 5px 6px;
                      "
                    >
                      Zone: {{ zone.name }}
                    </h5>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Tier
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let tier of product.tiers.tiersData">
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ tier.name }}
                          </td>
                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  '',
                                  '',
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Condition 6: Zone + Tier + Variant + Category -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-tier-variant-category'
              "
            >
              <h4 class="pricing-first-heading">
                Pricing: Zone → Tier → Variant → Category
              </h4>

              <div
                *ngFor="let zone of product.areas.areasData"
                style="margin-bottom: 30px"
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <div
                  *ngFor="let tier of product.tiers.tiersData"
                  style="margin-left: 15px; margin-bottom: 20px"
                >
                  <h6 class="pricing-third-heading">Tier: {{ tier.name }}</h6>

                  <!-- Variant Grid -->
                  <div
                    style="
                      display: flex;
                      flex-wrap: wrap;
                      gap: 20px;
                      margin-left: 15px;
                    "
                  >
                    <div
                      *ngFor="let variant of product.variants.variantsData"
                      style="
                        flex: 1 1 calc(33.333% - 20px);
                        background: #fff;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                        padding: 10px;
                        box-sizing: border-box;
                      "
                    >
                      <h6
                        style="
                          width: fit-content;
                          background-color: #142a49;
                          color: white;
                          width: fit-content;
                          background-color: #142a49;
                          color: white;
                          font-weight: 500;
                          font-size: 14px;
                          border-radius: 2px;
                          padding: 5px 6px;
                        "
                      >
                        Variant: {{ variant.name }}
                      </h6>

                      <table
                        style="
                          width: 100%;
                          border-collapse: collapse;
                          font-size: 13px;
                        "
                      >
                        <thead style="background-color: #808285; color: white">
                          <tr>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Category
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Unit Price
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Advisor Commission
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              TPA Commission
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Other Fees
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let category of product.serviceLevel.servicesData
                            "
                          >
                            <td style="padding: 6px; border: 1px solid #ccc">
                              {{ category.name }}
                            </td>
                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'Unit Price'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'Unit Price',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>
                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'Advisor Commission'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'Advisor Commission',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>
                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'TPA Commission'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'TPA Commission',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>
                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'Other Fees'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    tier.name,
                                    '',
                                    variant.name,
                                    category.name,
                                    'Other Fees',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 7: Zone + Age Band + Variant + Category (3 per row) -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-age-variant-category'
              "
            >
              <h4 class="pricing-first-heading">
                Pricing: Zone → Age Band → Variant → Category
              </h4>

              <div
                *ngFor="let zone of product.areas.areasData"
                style="margin-bottom: 30px"
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <div
                  *ngFor="let age of product.ageBands.ageBandsData"
                  style="margin-left: 15px; margin-bottom: 20px"
                >
                  <h6 class="pricing-third-heading">
                    Age Band: {{ age.start }} - {{ age.end }}
                  </h6>

                  <!-- 3 variants per row inside white cards -->
                  <div
                    style="
                      display: flex;
                      flex-wrap: wrap;
                      gap: 20px;
                      margin-left: 15px;
                    "
                  >
                    <div
                      *ngFor="let variant of product.variants.variantsData"
                      style="
                        flex: 1 1 calc(33.333% - 20px);
                        box-sizing: border-box;
                        background: white;
                        padding: 16px;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                        border-radius: 8px;
                      "
                    >
                      <h6
                        style="
                          width: fit-content;
                          background-color: #142a49;
                          color: white;
                          width: fit-content;
                          background-color: #142a49;
                          color: white;
                          font-weight: 500;
                          font-size: 14px;
                          border-radius: 2px;
                          padding: 5px 6px;
                        "
                      >
                        Variant:<strong> {{ variant.name }}</strong>
                      </h6>

                      <table
                        style="
                          width: 100%;
                          border-collapse: collapse;
                          font-size: 13px;
                        "
                      >
                        <thead style="background-color: #808285; color: white">
                          <tr>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Category
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Unit Price
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Advisor Commission
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              TPA Commission
                            </th>
                            <th style="padding: 6px; border: 1px solid #ccc">
                              Other Fees
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let category of product.serviceLevel.servicesData
                            "
                          >
                            <td style="padding: 6px; border: 1px solid #ccc">
                              {{ category.name }}
                            </td>

                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'Unit Price'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'Unit Price',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>

                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'Advisor Commission'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'Advisor Commission',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>

                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'TPA Commission'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'TPA Commission',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>

                            <td style="padding: 6px; border: 1px solid #ccc">
                              <input
                                type="text"
                                (keydown)="
                                  allowCurrencyOrPercent(
                                    $event,
                                    $event.target['value']
                                  )
                                "
                                (paste)="preventInvalidPaste($event)"
                                [ngModel]="
                                  getPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'Other Fees'
                                  )
                                "
                                (ngModelChange)="
                                  setPricingValue(
                                    zone.name,
                                    '',
                                    age.start + '-' + age.end,
                                    variant.name,
                                    category.name,
                                    'Other Fees',
                                    $event
                                  )
                                "
                                style="
                                  width: 100%;
                                  border: none;
                                  outline: none;
                                  text-align: center;
                                "
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 10: Zone → Age Band → Variant -->
            <ng-container
              style="
                margin-top: 8px;
                width: 100%;
                display: flex;
                flex-direction: column;
              "
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-age-variant'
              "
            >
              <h4 class="pricing-first-heading">
                Pricing: Zone → Age Band → Variant
              </h4>

              <!-- Loop through Zones -->
              <div
                *ngFor="let zone of product.areas.areasData"
                style="margin-bottom: 30px"
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <!-- Horizontal age-band card layout like tier cards -->
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    padding-left: 10px;
                    padding-right: 10px;
                  "
                >
                  <!-- Age Band Card -->
                  <div
                    *ngFor="let age of product.ageBands.ageBandsData"
                    style="
                      width: 32%;
                      min-width: 300px;
                      background: #fff;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                      padding: 12px;
                    "
                  >
                    <h6
                      class="pricing-third-heading"
                      style="text-align: center"
                    >
                      Age Band: {{ age.start }} - {{ age.end }}
                    </h6>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Variant
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let variant of product.variants.variantsData"
                        >
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ variant.name }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  variant.name,
                                  '',
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 11: Zone + Age Band + Category -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-age-category'
              "
            >
              <h4 class="pricing-first-heading">
                Pricing: Zone → Age Band → Category
              </h4>

              <!-- Loop through Zones -->
              <div
                *ngFor="let zone of product.areas.areasData"
                style="margin-bottom: 30px"
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <!-- Horizontal age band layout like tier cards -->
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    padding-left: 10px;
                    padding-right: 10px;
                  "
                >
                  <!-- Age Band Card -->
                  <div
                    *ngFor="let age of product.ageBands.ageBandsData"
                    style="
                      width: 32%;
                      min-width: 300px;
                      background: #fff;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                      padding: 12px;
                    "
                  >
                    <h6
                      class="pricing-third-heading"
                      style="text-align: center"
                    >
                      Age Band: {{ age.start }} - {{ age.end }}
                    </h6>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Category
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let category of product.serviceLevel.servicesData
                          "
                        >
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ category.name }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  category.name,
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 12: Zone + Tier + Variant -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-tier-variant'
              "
            >
              <h4 class="pricing-first-heading">
                Pricing: Zone → Tier → Variant
              </h4>

              <!-- Loop through Zones -->
              <div
                *ngFor="let zone of product.areas.areasData"
                style="margin-bottom: 30px"
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <!-- Horizontal tier layout like cards -->
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    padding-left: 10px;
                    padding-right: 10px;
                  "
                >
                  <!-- Tier Card -->
                  <div
                    *ngFor="let tier of product.tiers.tiersData"
                    style="
                      width: 32%;
                      min-width: 300px;
                      background: #fff;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                      padding: 12px;
                    "
                  >
                    <h6
                      class="pricing-third-heading"
                      style="text-align: center"
                    >
                      Tier: {{ tier.name }}
                    </h6>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Variant
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let variant of product.variants.variantsData"
                        >
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ variant.name }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  tier.name,
                                  '',
                                  variant.name,
                                  '',
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 15: Zone + Variant + Category (Card Layout) -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-variant-category'
              "
            >
              <h4 class="pricing-first-heading">
                Pricing: Zone → Variant → Category
              </h4>

              <!-- Loop through Zones -->
              <div
                *ngFor="let zone of product.areas.areasData"
                style="margin-bottom: 30px"
              >
                <h5 class="pricing-second-heading">Zone: {{ zone.name }}</h5>

                <!-- Variant Cards Row -->
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    padding-left: 10px;
                    padding-right: 10px;
                  "
                >
                  <!-- Variant Card -->
                  <div
                    *ngFor="let variant of product.variants.variantsData"
                    style="
                      width: 32%;
                      min-width: 300px;
                      background: #fff;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                      padding: 12px;
                    "
                  >
                    <h6 style="text-align: center; margin-bottom: 10px">
                      Variant: {{ variant.name }}
                    </h6>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Category
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let category of product.serviceLevel.servicesData
                          "
                        >
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ category.name }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  category.name,
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 20: Zone + Variant (right) -->
            <!-- Condition 20: Zone + Variant (right) -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-variant'
              "
            >
              <h4 class="pricing-first-heading">Pricing: Zone → Variant</h4>

              <!-- Chunked rows of 3 zones -->
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  gap: 20px;
                  margin-top: 16px;
                "
              >
                <div
                  *ngFor="let zone of product.areas.areasData"
                  style="flex: 1 1 calc(33.333% - 20px); box-sizing: border-box"
                >
                  <!-- White card for each zone -->
                  <div
                    style="
                      background: white;
                      padding: 16px;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      margin-bottom: 30px;
                    "
                  >
                    <h5
                      style="
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        font-weight: 500;
                        font-size: 14px;
                        border-radius: 2px;
                        padding: 5px 6px;
                      "
                    >
                      Zone: {{ zone.name }}
                    </h5>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Variant
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let variant of product.variants.variantsData"
                        >
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ variant.name }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  variant.name,
                                  '',
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 21: Zone + Category (right) -->
            <!-- Condition 21: Zone + Category (right) -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-category'
              "
            >
              <h4 class="pricing-first-heading">Pricing: Zone → Category</h4>

              <!-- Wrapper to make 3 zone tables per row -->
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  gap: 20px;
                  margin-top: 16px;
                "
              >
                <div
                  *ngFor="let zone of product.areas.areasData"
                  style="flex: 1 1 calc(33.333% - 20px); box-sizing: border-box"
                >
                  <!-- White card -->
                  <div
                    style="
                      background: white;
                      padding: 16px;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      margin-bottom: 30px;
                    "
                  >
                    <h5
                      style="
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        font-weight: 500;
                        font-size: 14px;
                        border-radius: 2px;
                        padding: 5px 6px;
                      "
                    >
                      Zone: {{ zone.name }}
                    </h5>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Category
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let category of product.serviceLevel.servicesData
                          "
                        >
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ category.name }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  '',
                                  '',
                                  category.name,
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Condition 23: Zone → Age (right) -->
            <ng-container
              style="margin-top: 8px"
              *ngIf="
                product.pricing.showPricingTable &&
                product.pricing.showTableType === 'zone-age'
              "
            >
              <h4 class="pricing-first-heading">Pricing: Zone → Age Band</h4>

              <!-- Wrapper for flex layout: 3 zones per row -->
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  gap: 20px;
                  margin-top: 16px;
                "
              >
                <div
                  *ngFor="let zone of product.areas.areasData"
                  style="flex: 1 1 calc(33.333% - 20px); box-sizing: border-box"
                >
                  <!-- White box with shadow -->
                  <div
                    style="
                      background: white;
                      padding: 16px;
                      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      margin-bottom: 30px;
                    "
                  >
                    <h6
                      style="
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        width: fit-content;
                        background-color: #142a49;
                        color: white;
                        font-weight: 500;
                        font-size: 14px;
                        border-radius: 2px;
                        padding: 5px 6px;
                      "
                    >
                      Zone: {{ zone.name }}
                    </h6>

                    <table
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                      "
                    >
                      <thead style="background-color: #808285; color: white">
                        <tr>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Age Band
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Unit Price
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Advisor Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            TPA Commission
                          </th>
                          <th style="padding: 6px; border: 1px solid #ccc">
                            Other Fees
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let age of product.ageBands.ageBandsData">
                          <td style="padding: 6px; border: 1px solid #ccc">
                            {{ age.start }} - {{ age.end }}
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'Unit Price'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'Unit Price',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'Advisor Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'Advisor Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'TPA Commission'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'TPA Commission',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>

                          <td style="padding: 6px; border: 1px solid #ccc">
                            <input
                              type="text"
                              (keydown)="
                                allowCurrencyOrPercent(
                                  $event,
                                  $event.target['value']
                                )
                              "
                              (paste)="preventInvalidPaste($event)"
                              [ngModel]="
                                getPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'Other Fees'
                                )
                              "
                              (ngModelChange)="
                                setPricingValue(
                                  zone.name,
                                  '',
                                  age.start + '-' + age.end,
                                  '',
                                  '',
                                  'Other Fees',
                                  $event
                                )
                              "
                              style="
                                width: 100%;
                                border: none;
                                outline: none;
                                text-align: center;
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <!-- update button  -->
          <div
            style="
              width: 100%;
              position: sticky;
              bottom: 0;
              background-color: white;
              z-index: 10;
              padding: 10px 20px;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <!-- Cancel -->
            <button
              class="btn btn-success btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #fff;
                color: #142a49;
              "
              (click)="handleCancel()"
            >
              Cancel
            </button>

            <!-- Update -->
            <button
              *ngIf="productModalMode !== 'view' && isProductValidForFirstRow"
              class="btn btn-success btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #142a49;
                color: #fff;
              "
              (click)="
                onUpdateProduct(product.productInfo.productId)
              "
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
